(function (global) {
  const QUIZ_DEBUG = false;
  const QUIZ_RESULT_STORAGE_KEY = 'solvi:fragrance-quiz:last-result';

  const PATH_ALIASES = {
    beginner: 'curious',
    'beginner-path': 'curious',
    notes: 'fluent',
    'notes-path': 'fluent',
    curious: 'curious',
    'scent-curious': 'curious',
    'new-here': 'curious',
    'new_here': 'curious',
    'im-new-here': 'curious',
    'i-m-new-here': 'curious',
    'i’m-new-here': 'curious',
    fluent: 'fluent',
    'fragrance-fluent': 'fluent',
    'know-my-notes': 'fluent',
    'i-know-my-notes': 'fluent'
  };

  const INTENSITY_LEVELS = {
    whisper: 1,
    soft: 2,
    'soft-medium': 2.5,
    'soft–medium': 2.5,
    medium: 3,
    bold: 4,
    loud: 5
  };

  const BLIND_BUY_LEVELS = {
    'easy blind buy': 1,
    'confident pick': 2,
    'safe with personality': 3,
    'experimental/niche lover': 4,
    'experimental niche lover': 4
  };

  const NOTE_GROUPS = {
    vanillaTonka: {
      label: 'vanilla / tonka',
      aliases: ['vanilla', 'tonka', 'tonka bean']
    },
    amberResins: {
      label: 'amber / resins',
      aliases: ['amber', 'labdanum', 'benzoin', 'myrrh', 'frankincense', 'olibanum', 'resin', 'resins']
    },
    musk: {
      label: 'musk',
      aliases: ['musk', 'white musk', 'skin musk', 'ambrette']
    },
    woods: {
      label: 'sandalwood / cedar / woods',
      aliases: ['sandalwood', 'cedar', 'cedarwood', 'guaiac', 'guaiac wood', 'oak', 'hinoki', 'cashmere wood']
    },
    florals: {
      label: 'rose / jasmine / florals',
      aliases: ['rose', 'jasmine', 'tuberose', 'gardenia', 'orange blossom', 'iris', 'orris', 'violet', 'ylang ylang', 'magnolia', 'lilac']
    },
    citrus: {
      label: 'citrus',
      aliases: ['bergamot', 'lemon', 'lime', 'grapefruit', 'mandarin', 'orange', 'yuzu', 'citron', 'pomelo']
    },
    fruits: {
      label: 'fig / berries / fruit',
      aliases: ['fig', 'strawberry', 'raspberry', 'blackberry', 'blueberry', 'cherry', 'pear', 'peach', 'plum', 'mango', 'pineapple', 'apple', 'apricot', 'banana', 'coconut']
    },
    tea: {
      label: 'tea',
      aliases: ['black tea', 'green tea', 'oolong', 'matcha', 'maté', 'mate', 'rooibos', 'tea']
    },
    greenHerbal: {
      label: 'green / herbal notes',
      aliases: ['galbanum', 'basil', 'sage', 'mint', 'shiso', 'thyme', 'rosemary', 'grass', 'leaves', 'ivy', 'eucalyptus', 'juniper']
    },
    spices: {
      label: 'spices',
      aliases: ['cinnamon', 'cardamom', 'clove', 'nutmeg', 'saffron', 'pepper', 'pink pepper', 'ginger', 'coriander', 'anise']
    },
    smokeLeather: {
      label: 'tobacco / leather / smoke',
      aliases: ['tobacco', 'leather', 'suede', 'smoke', 'smoky', 'cade', 'birch tar']
    }
  };

  const SOFT_AVOID_ALIASES = {
    smokeLeather: ['leather', 'suede', 'smoke', 'smoky', 'cade', 'birch tar'],
    syntheticBase: ['ambroxan', 'ambrofix', 'cetalox', 'iso e super', 'cashmeran', 'norlimbanol', 'amber xtreme']
  };

  const FAMILY_COPY = {
    gourmand: ['your gourmands', 'your sweeter scents'],
    amber: ['your amber scents', 'your warm scents'],
    woody: ['your woody scents'],
    spicy: ['your spicier scents'],
    musky: ['your musks', 'your skin scents'],
    musk: ['your musks', 'your skin scents'],
    floral: ['your florals'],
    fruity: ['your fruity scents'],
    citrus: ['your citrus scents', 'your fresher scents'],
    fresh: ['your fresh scents'],
    green: ['your green scents'],
    aromatic: ['your green, aromatic scents'],
    aquatic: ['your fresh scents', 'your aquatic scents'],
    earthy: ['your earthy scents']
  };

  const FAMILY_TEXTURE_COPY = {
    gourmand: ['creamy', 'indulgent', 'a little polished'],
    amber: ['warm', 'rich', 'a little dangerous'],
    woody: ['textured', 'magnetic', 'quietly moody'],
    spicy: ['warm', 'textured', 'lively'],
    musky: ['soft', 'personal', 'clean'],
    floral: ['pretty', 'polished', 'interesting'],
    fruity: ['juicy', 'playful', 'easygoing'],
    citrus: ['crisp', 'bright', 'sunny'],
    fresh: ['crisp', 'easy', 'expensive-feeling'],
    green: ['crisp', 'interesting', 'a little unexpected'],
    aromatic: ['clean', 'grounded', 'interesting'],
    aquatic: ['fresh', 'easy', 'breezy'],
    earthy: ['grounded', 'interesting', 'a little unexpected']
  };

  const FAMILY_TASTE_COPY = {
    gourmand: {
      subjects: [{ text: 'something sweet but grown up', plural: false }, { text: 'comforting sweetness', plural: false }],
      concept: 'sweetness',
      qualities: ['creamy', 'cozy', 'polished'],
      plotQualities: ['sweet', 'soft', 'grown up']
    },
    amber: {
      subjects: [{ text: 'warmth', plural: false }, { text: 'smooth warmth', plural: false }, { text: 'something rich and cocooning', plural: false }],
      concept: 'warmth',
      qualities: ['smooth', 'cozy', 'quietly luxe'],
      plotQualities: ['rich', 'comforting', 'easy to wear']
    },
    woody: {
      subjects: [{ text: 'deeper scents', plural: true }, { text: 'soft woods', plural: true }, { text: 'something grounded and polished', plural: false }],
      concept: 'depth',
      qualities: ['soft', 'polished', 'easy to melt into'],
      plotQualities: ['soft', 'polished', 'easy to wear']
    },
    spicy: {
      subjects: [{ text: 'warmth with a little spark', plural: false }, { text: 'something textured and cozy', plural: false }],
      concept: 'warmth',
      qualities: ['warm', 'textured', 'interesting'],
      plotQualities: ['warm', 'inviting', 'easy to wear']
    },
    musky: {
      subjects: [{ text: 'something soft and intimate', plural: false }, { text: 'close-to-the-skin softness', plural: false }],
      concept: 'softness',
      qualities: ['soft', 'intimate', 'quietly addictive'],
      plotQualities: ['soft', 'personal', 'easy to wear']
    },
    musk: {
      subjects: [{ text: 'something soft and intimate', plural: false }, { text: 'close-to-the-skin softness', plural: false }],
      concept: 'softness',
      qualities: ['soft', 'intimate', 'quietly addictive'],
      plotQualities: ['soft', 'personal', 'easy to wear']
    },
    floral: {
      subjects: [{ text: 'something pretty with a little edge', plural: false }, { text: 'soft prettiness', plural: false }],
      concept: 'prettiness',
      qualities: ['pretty', 'polished', 'memorable'],
      plotQualities: ['pretty', 'soft', 'grown up']
    },
    fruity: {
      subjects: [{ text: 'something juicy and playful', plural: false }, { text: 'playful brightness', plural: false }],
      concept: 'playfulness',
      qualities: ['juicy', 'playful', 'easygoing'],
      plotQualities: ['bright', 'playful', 'easy to wear']
    },
    citrus: {
      subjects: [{ text: 'freshness', plural: false }, { text: 'something bright and polished', plural: false }],
      concept: 'freshness',
      qualities: ['polished', 'bright', 'a little grown up'],
      plotQualities: ['bright', 'polished', 'easy to wear']
    },
    fresh: {
      subjects: [{ text: 'freshness', plural: false }, { text: 'something clean and easy', plural: false }],
      concept: 'freshness',
      qualities: ['sunny', 'polished', 'easy'],
      plotQualities: ['clean', 'bright', 'easy to wear']
    },
    green: {
      subjects: [{ text: 'crisp freshness', plural: false }, { text: 'something green and unexpected', plural: false }],
      concept: 'freshness',
      qualities: ['crisp', 'interesting', 'unexpected'],
      plotQualities: ['crisp', 'green', 'easy to wear']
    },
    aromatic: {
      subjects: [{ text: 'something clean but grounded', plural: false }, { text: 'freshness with a little character', plural: false }],
      concept: 'freshness',
      qualities: ['clean', 'grounded', 'interesting'],
      plotQualities: ['clean', 'grounded', 'easy to wear']
    },
    aquatic: {
      subjects: [{ text: 'breezy freshness', plural: false }, { text: 'something clean and airy', plural: false }],
      concept: 'freshness',
      qualities: ['fresh', 'easy', 'breezy'],
      plotQualities: ['fresh', 'airy', 'easy to wear']
    },
    earthy: {
      subjects: [{ text: 'grounded depth', plural: false }, { text: 'something earthy and unexpected', plural: false }],
      concept: 'depth',
      qualities: ['grounded', 'interesting', 'unexpected'],
      plotQualities: ['grounded', 'soft', 'easy to wear']
    }
  };

  const MOOD_TASTE_COPY = {
    'warm & cozy': ['smooth', 'cozy', 'comforting'],
    'dark & moody': ['moody', 'rich', 'soft'],
    'bright & easy': ['sunny', 'bright', 'easy'],
    'soft & skin-like': ['soft', 'intimate', 'quietly addictive'],
    'clean & effortless': ['clean', 'polished', 'easy'],
    'sweet & chic': ['sweet', 'grown up', 'playful']
  };

  const MOOD_COPY = {
    'warm & cozy': ['cozy', 'comforting', 'warm', 'easy to get attached to'],
    'dark & moody': ['dark', 'moody', 'a little mysterious', 'with a darker edge'],
    'bright & easy': ['bright', 'easygoing', 'sunny', 'effortless'],
    'soft & skin-like': ['soft', 'intimate', 'close-to-the-skin', 'quietly addictive'],
    'clean & effortless': ['clean', 'fresh', 'polished without trying too hard', 'put together'],
    'sweet & chic': ['sweet but polished', 'a little dressed up', 'chic', 'delicious without feeling childish']
  };

  const INTENSITY_COPY = {
    whisper: ['that stay close to the skin', 'with a barely-there trail', 'that feel more like a secret than a statement'],
    soft: ['with a quiet, intimate trail', 'that stay easy and close', 'with more come-closer energy than make-an-entrance energy'],
    'soft-medium': ['that get better the closer you get', 'with just enough presence to keep things interesting'],
    medium: ['with just enough presence to feel intentional', 'with a clear trail that still knows its manners'],
    bold: ['with enough presence to get noticed', 'that are not planning to disappear quietly', 'with a confident amount of presence'],
    loud: ['that know how to make an entrance', 'with enough presence to make an entrance', 'that are absolutely not here to whisper']
  };

  const NOTE_GROUP_COPY = {
    vanillaTonka: 'especially when vanilla is involved',
    amberResins: 'with amber doing some of the warming',
    musk: 'with musk keeping things close',
    woods: 'with woods doing some of the grounding',
    florals: 'with florals adding a little softness',
    citrus: 'with citrus keeping things bright',
    fruits: 'with fruit keeping things playful',
    tea: 'with tea doing some of the heavy lifting',
    greenHerbal: 'with greenery keeping things interesting',
    spices: 'with spice in the mix',
    smokeLeather: 'with smoke or leather adding an edge'
  };

  const GOOD_FOR_COPY = {
    'date night': 'very comfortable with a late reservation',
    everyday: 'easy enough for every day without feeling forgettable',
    work: 'polished enough for real-life plans',
    'special occasion': 'ready to be a little dressed up',
    vacation: 'ready for windows-down weather'
  };

  // Approved Solvi quiz flow rendered into the existing quiz shell UI.
  const QUESTIONS = [
    {
      id: 'a01-feel',
      path: 'curious',
      kicker: 'question 01',
      title: 'How do you want your fragrance to make you feel?',
      helper: 'Pick the one that feels most like your lane.',
      type: 'single',
      options: [
        { key: 'powerful_dangerous', label: 'Powerful and (fun) dangerous', description: 'Leather, oud, deep spicy amber', scoring: { moods: { 'Dark & Moody': 5, 'Warm & Cozy': 1 }, families: { Amber: 4, Woody: 3, Spicy: 3 } } },
        { key: 'effortless_clean', label: 'Effortless and clean', description: 'Just-showered energy', scoring: { moods: { 'Clean & Effortless': 5, 'Soft & Skin-like': 1 }, families: { Fresh: 4, Citrus: 2, Musky: 1, Green: 1, Aromatic: 1 } } },
        { key: 'dressed_up', label: 'Dressed up for something', description: 'Elegant, a little mysterious', scoring: { moods: { 'Sweet & Chic': 4, 'Dark & Moody': 3 }, families: { Amber: 2, Floral: 2, Woody: 1 } } },
        { key: 'myself_better', label: 'Like myself, only better', description: 'Subtle, intimate, skin-like', scoring: { moods: { 'Soft & Skin-like': 5, 'Clean & Effortless': 2 }, families: { Musky: 4, Woody: 1 } } },
        { key: 'sundrunk', label: 'Sundrunk & carefree', description: 'Vacation in a bottle', scoring: { moods: { 'Bright & Easy': 5, 'Clean & Effortless': 1 }, families: { Citrus: 4, Fruity: 3, Aquatic: 2, Green: 1 } } },
        { key: 'delicious_expensive', label: 'Delicious & expensive', description: 'Sweet, chic, addictive', scoring: { moods: { 'Sweet & Chic': 5, 'Warm & Cozy': 2 }, families: { Gourmand: 4, Amber: 2, Fruity: 1 } } },
        { key: 'soft_comforting', label: 'Soft and comforting', description: 'Hug-in-a-bottle feeling', scoring: { moods: { 'Warm & Cozy': 5, 'Soft & Skin-like': 3 }, families: { Gourmand: 2, Musky: 2, Woody: 2, Amber: 2 } } },
        { key: 'wild_strange', label: 'Wild and strange', description: "Scents that don't play by the rules", scoring: { moods: { 'Dark & Moody': 4, 'Clean & Effortless': 1 }, families: { Earthy: 2, Aromatic: 2, Woody: 1 } } }
      ]
    },
    {
      id: 'a02-scene',
      path: 'curious',
      kicker: 'question 02',
      title: 'Pick your scene.',
      type: 'single',
      options: [
        { key: 'late_reservation', label: 'Late reservation, low lighting, ordering an app for the table', scoring: { moods: { 'Dark & Moody': 3, 'Sweet & Chic': 2 }, goodFor: { 'Date Night': 1 } } },
        { key: 'everything_shower', label: 'Everything shower, your favorite playlist', scoring: { moods: { 'Clean & Effortless': 3, 'Soft & Skin-like': 2 }, goodFor: { Everyday: 1 } } },
        { key: 'uber_downtown', label: 'Uber downtown, cool night, you spot your friends', scoring: { moods: { 'Bright & Easy': 2, 'Dark & Moody': 2 }, goodFor: { 'Special Occasion': 1 } } },
        { key: 'fresh_sheets_book', label: 'Fresh sheets, new book, no plans', scoring: { moods: { 'Soft & Skin-like': 3, 'Warm & Cozy': 2 }, goodFor: { Everyday: 1 } } },
        { key: 'windows_down', label: "Windows down, you haven’t worn a close-toe shoe in days", scoring: { moods: { 'Bright & Easy': 3, 'Clean & Effortless': 1 }, goodFor: { Everyday: 1 } } },
        { key: 'cafe_crawl', label: 'Cafe crawl with your lover, big new city', scoring: { moods: { 'Sweet & Chic': 2, 'Bright & Easy': 2, 'Warm & Cozy': 1 }, goodFor: { 'Date Night': 1 } } },
        { key: 'hosting_home', label: 'Hosting at home, feeding a happy crowd', scoring: { moods: { 'Warm & Cozy': 3, 'Sweet & Chic': 1 }, goodFor: { Everyday: 1 } } },
        { key: 'festival', label: 'Vibrant festival, cool outfit, phone battery at 2%', scoring: { moods: { 'Bright & Easy': 3, 'Sweet & Chic': 1 }, goodFor: { 'Special Occasion': 1 } } }
      ]
    },
    {
      id: 'a03-nose',
      path: 'curious',
      kicker: 'question 03',
      title: 'Which of these sounds best to your nose?',
      helper: 'Choose up to two.',
      type: 'multi',
      maxSelections: 2,
      options: [
        { key: 'vanilla_woods_amber', label: 'Creamy vanilla, warm woods & soft amber', scoring: { moods: { 'Warm & Cozy': 3, 'Sweet & Chic': 2 }, families: { Gourmand: 4, Amber: 4, Woody: 2 } } },
        { key: 'smoke_spice_leather', label: 'Smoke, spice, leather & dark woods', scoring: { moods: { 'Dark & Moody': 4 }, families: { Woody: 4, Spicy: 3, Amber: 2 } } },
        { key: 'citrus_fruit_herbs', label: 'Citrus, juicy fruit & fresh herbs', scoring: { moods: { 'Bright & Easy': 3, 'Clean & Effortless': 2 }, families: { Citrus: 4, Fruity: 3, Green: 2, Aromatic: 2 } } },
        { key: 'musk_skin_woods', label: 'Soft musk, clean skin & sheer woods', scoring: { moods: { 'Soft & Skin-like': 4, 'Clean & Effortless': 2 }, families: { Musky: 4, Woody: 2 } } },
        { key: 'tea_green_florals', label: 'Tea, greenery & airy florals', scoring: { moods: { 'Clean & Effortless': 3, 'Bright & Easy': 2, 'Soft & Skin-like': 1 }, families: { Green: 3, Aromatic: 3, Floral: 2, Fresh: 2 } } },
        { key: 'fruit_petals_sweet', label: 'Fruit, petals & something sweet', scoring: { moods: { 'Sweet & Chic': 3, 'Bright & Easy': 2 }, families: { Fruity: 4, Floral: 3, Gourmand: 1 } } },
        { key: 'earth_fog_leaves', label: 'Fresh earth, foggy haze & crushed leaves', scoring: { moods: { 'Dark & Moody': 3, 'Clean & Effortless': 2 }, families: { Earthy: 4, Green: 3, Aromatic: 3, Woody: 2 } } }
      ]
    },
    {
      id: 'b01-families',
      path: 'fluent',
      kicker: 'question 01',
      title: 'What scent families do you usually reach for?',
      helper: 'Pick whatever genuinely pulls you in.',
      type: 'multi',
      options: [
        { key: 'woody', label: 'Woody', scoring: { families: { Woody: 5 } } },
        { key: 'amber_spicy', label: 'Amber / Spicy', scoring: { families: { Amber: 5, Spicy: 5 } } },
        { key: 'gourmand', label: 'Gourmand', scoring: { families: { Gourmand: 5 } } },
        { key: 'floral', label: 'Floral', scoring: { families: { Floral: 5 } } },
        { key: 'fresh_citrus', label: 'Fresh / Citrus', scoring: { families: { Fresh: 5, Citrus: 5 } } },
        { key: 'green_aromatic', label: 'Green / Aromatic', scoring: { families: { Green: 5, Aromatic: 5 } } },
        { key: 'musk_skin', label: 'Musk / Skin scents', scoring: { families: { Musky: 5 } } },
        { key: 'fruity', label: 'Fruity', scoring: { families: { Fruity: 5 } } },
        { key: 'family_any', label: 'Honestly, I’m all over the place', exclusiveGroup: 'families-any', scoring: {} }
      ]
    },
    {
      id: 'b02-notes',
      path: 'fluent',
      kicker: 'question 02',
      title: 'What notes always get you?',
      helper: 'Choose as many as feel true.',
      type: 'multi',
      options: [
        { key: 'vanilla_tonka', label: 'Vanilla / tonka bean', scoring: { favoriteNoteGroup: 'vanillaTonka' } },
        { key: 'amber_resins', label: 'Amber / resins', scoring: { favoriteNoteGroup: 'amberResins' } },
        { key: 'musk', label: 'Musk', scoring: { favoriteNoteGroup: 'musk' } },
        { key: 'woods', label: 'Sandalwood / cedar / other woods', scoring: { favoriteNoteGroup: 'woods' } },
        { key: 'florals', label: 'Rose / jasmine / florals', scoring: { favoriteNoteGroup: 'florals' } },
        { key: 'citrus', label: 'Citrus', scoring: { favoriteNoteGroup: 'citrus' } },
        { key: 'fruits', label: 'Fig / berries / other fruits', scoring: { favoriteNoteGroup: 'fruits' } },
        { key: 'tea', label: 'Tea', scoring: { favoriteNoteGroup: 'tea' } },
        { key: 'green_herbal', label: 'Green / herbal notes', scoring: { favoriteNoteGroup: 'greenHerbal' } },
        { key: 'spices', label: 'Spices', scoring: { favoriteNoteGroup: 'spices' } },
        { key: 'tobacco_leather_smoke', label: 'Tobacco / leather / smoke', scoring: { favoriteNoteGroup: 'smokeLeather' } },
        { key: 'notes_other', label: 'Something else', freeText: true, scoring: {} }
      ]
    },
    {
      id: 'b03-avoid',
      path: 'fluent',
      kicker: 'question 03',
      title: 'Anything you normally avoid?',
      helper: 'These are soft avoidances, not dealbreakers.',
      type: 'multi',
      options: [
        { key: 'very_sweet', label: 'Very sweet scents', scoring: { softAvoid: 'very_sweet' } },
        { key: 'indolic_florals', label: 'Indolic florals', scoring: { softAvoid: 'indolic_florals' } },
        { key: 'powdery', label: 'Powdery scents', scoring: { softAvoid: 'powdery' } },
        { key: 'smoky_leathery', label: 'Smoky / leathery scents', scoring: { softAvoid: 'smoky_leathery' } },
        { key: 'patchouli', label: 'Strong patchouli', scoring: { softAvoid: 'patchouli' } },
        { key: 'sharp_citrus', label: 'Sharp citrus', scoring: { softAvoid: 'sharp_citrus' } },
        { key: 'green_herbal_scents', label: 'Green / herbal scents', scoring: { softAvoid: 'green_herbal' } },
        { key: 'heavy_spice', label: 'Heavy spice', scoring: { softAvoid: 'heavy_spice' } },
        { key: 'fruity_scents', label: 'Fruity scents', scoring: { softAvoid: 'fruity' } },
        { key: 'synthetic_base', label: 'Synthetic base notes', scoring: { softAvoid: 'synthetic_base' } },
        { key: 'avoid_none', label: "Nothing’s off limits", exclusiveGroup: 'soft-avoid-none', scoring: {} },
        { key: 'avoid_specific', label: 'Something specific', freeText: true, scoring: {} }
      ]
    },
    {
      id: 'q04-intensity',
      path: 'both',
      kicker: 'question 04',
      title: 'How loud are we going?',
      type: 'single',
      options: [
        { key: 'keep_close', label: 'Keep it close', scoring: { intensityTarget: 1.5 } },
        { key: 'easy_notice', label: 'Easy to notice', scoring: { intensityTarget: 2.75 } },
        { key: 'compliments', label: 'I want compliments', scoring: { intensityTarget: 3.75 } },
        { key: 'entrance', label: 'Make an entrance', scoring: { intensityTarget: 4.75 } }
      ]
    },
    {
      id: 'q05-wear',
      path: 'both',
      kicker: 'question 05',
      title: 'Where are you most likely to wear it?',
      helper: 'Choose up to two.',
      type: 'multi',
      maxSelections: 2,
      options: [
        { key: 'everyday', label: 'Everyday, everywhere', scoring: { goodFor: { Everyday: 3 } } },
        { key: 'work_daytime', label: 'Work / daytime', scoring: { goodFor: { Work: 3, Everyday: 1 } } },
        { key: 'date_night', label: 'Date night', scoring: { goodFor: { 'Date Night': 3 } } },
        { key: 'going_out', label: 'Going out', scoring: { goodFor: { 'Special Occasion': 2, 'Date Night': 1 } } },
        { key: 'cozy_home', label: 'Cozy days at home', scoring: { moods: { 'Warm & Cozy': 2, 'Soft & Skin-like': 1 }, goodFor: { Everyday: 1 } } },
        { key: 'vacation', label: 'Vacation', scoring: { moods: { 'Bright & Easy': 2, 'Clean & Effortless': 1 }, goodFor: { Everyday: 1 } } },
        { key: 'special_occasion', label: 'Special occasions', scoring: { goodFor: { 'Special Occasion': 3 } } },
        { key: 'signature_everything', label: 'I want one signature scent that can do everything', scoring: { goodFor: { Everyday: 2 }, versatilityBonus: true } }
      ]
    },
    {
      id: 'q06-adventure',
      path: 'both',
      kicker: 'question 06',
      title: 'How adventurous should we get?',
      type: 'single',
      options: [
        { key: 'easy_love', label: 'Give me an easy love.', scoring: { blindBuyTarget: 1 } },
        { key: 'push_little', label: 'Push me a little.', scoring: { blindBuyTarget: 3 } },
        { key: 'surprise_me', label: 'Surprise me.', scoring: { blindBuyTarget: 4 } }
      ]
    },
    {
      id: 'q07-dealbreakers',
      path: 'both',
      kicker: 'question 07',
      title: 'Any actual dealbreakers?',
      helper: "Only tick these if you really don't want them showing up in your recommendations.",
      type: 'multi',
      options: [
        { key: 'vanilla', label: 'Vanilla', scoring: { dealbreaker: 'vanilla' } },
        { key: 'rose', label: 'Rose', scoring: { dealbreaker: 'rose' } },
        { key: 'coconut', label: 'Coconut', scoring: { dealbreaker: 'coconut' } },
        { key: 'patchouli', label: 'Patchouli', scoring: { dealbreaker: 'patchouli' } },
        { key: 'leather', label: 'Leather', scoring: { dealbreaker: 'leather' } },
        { key: 'tobacco', label: 'Tobacco', scoring: { dealbreaker: 'tobacco' } },
        { key: 'honey', label: 'Honey', scoring: { dealbreaker: 'honey' } },
        { key: 'powdery', label: 'Powdery', scoring: { dealbreaker: 'powdery' } },
        { key: 'smoky', label: 'Smoky', scoring: { dealbreaker: 'smoky' } },
        { key: 'heavy_floral', label: 'Heavy floral', scoring: { dealbreaker: 'heavy_floral' } },
        { key: 'green_herbal', label: 'Green / herbal', scoring: { dealbreaker: 'green_herbal' } },
        { key: 'fruity', label: 'Fruity', scoring: { dealbreaker: 'fruity' } },
        { key: 'dealbreakers_none', label: "Nothing’s off limits", exclusiveGroup: 'dealbreaker-none', scoring: {} }
      ]
    }
  ];

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’‘]/g, "'")
      .replace(/[–—]/g, '-')
      .replace(/&/g, ' and ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function normalizeTerm(value) {
    return normalizeText(value).replace(/[^a-z0-9+/#\s-]/g, '').replace(/\s+/g, ' ').trim();
  }

  function normalizeMood(value) {
    const key = normalizeTerm(value);
    const aliases = {
      'warm and cozy': 'Warm & Cozy',
      'warm cozy': 'Warm & Cozy',
      'dark and moody': 'Dark & Moody',
      'dark moody': 'Dark & Moody',
      'bright and easy': 'Bright & Easy',
      'fresh and bright': 'Bright & Easy',
      'fresh bright': 'Bright & Easy',
      'soft and skin-like': 'Soft & Skin-like',
      'soft skin-like': 'Soft & Skin-like',
      'soft skin like': 'Soft & Skin-like',
      'clean and effortless': 'Clean & Effortless',
      'clean effortless': 'Clean & Effortless',
      'sweet and chic': 'Sweet & Chic',
      'sweet chic': 'Sweet & Chic'
    };
    return aliases[key] || value;
  }

  function normalizeFamily(value) {
    const key = normalizeTerm(value);
    const aliases = {
      musk: 'Musky',
      musks: 'Musky',
      musky: 'Musky',
      skin: 'Musky',
      wood: 'Woody',
      woods: 'Woody',
      woody: 'Woody',
      citrusy: 'Citrus',
      gourmand: 'Gourmand',
      gourmandes: 'Gourmand',
      amber: 'Amber',
      ambery: 'Amber',
      spice: 'Spicy',
      spicy: 'Spicy',
      fresh: 'Fresh',
      green: 'Green',
      aromatic: 'Aromatic',
      floral: 'Floral',
      florals: 'Floral',
      fruity: 'Fruity',
      fruit: 'Fruity',
      aquatic: 'Aquatic',
      earthy: 'Earthy',
      'white floral': 'White Floral',
      'yellow floral': 'Yellow Floral'
    };
    return aliases[key] || titleCase(key);
  }

  function titleCase(value) {
    return String(value || '').replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
  }

  function toList(value) {
    if (value == null || value === false) return [];
    if (Array.isArray(value)) return value.flatMap(toList);
    if (typeof value === 'object') {
      if ('label' in value) return toList(value.label);
      if ('name' in value) return toList(value.name);
      if ('value' in value) return toList(value.value);
      return [];
    }
    return String(value)
      .split(/[;|,]/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function addMap(target, values = {}) {
    Object.entries(values).forEach(([key, amount]) => {
      const normalizedKey = key.includes('&') || key.includes('Mood') ? normalizeMood(key) : key;
      target[normalizedKey] = (target[normalizedKey] || 0) + Number(amount || 0);
    });
  }

  function unique(values) {
    return [...new Set(values.filter(Boolean))];
  }

  function normalizeProduct(product) {
    const notes = [
      ...toList(product.topNotes),
      ...toList(product.heartNotes),
      ...toList(product.baseNotes)
    ];
    const searchableTags = toList(product.tags).filter((tag) => !normalizeTerm(tag).startsWith('svm-'));
    const scentMoods = toList(product.scentMoods).map(normalizeMood).filter(Boolean);
    const primaryFamily = normalizeFamily(toList(product.primaryFamily)[0] || product.primaryFamily || '');
    const secondaryFamilies = toList(product.secondaryFamilies).map(normalizeFamily).filter(Boolean);
    const goodFor = toList(product.goodFor).map(titleCase);
    const noteTerms = unique([...notes, ...searchableTags].map(normalizeTerm));
    const descriptiveText = normalizeTerm([
      product.vibe,
      product.smellsLike,
      product.ourTake,
      product.description
    ].flatMap(toList).join(' '));

    return {
      ...product,
      scentMoods,
      primaryFamily,
      secondaryFamilies,
      goodFor,
      topNotes: toList(product.topNotes),
      heartNotes: toList(product.heartNotes),
      baseNotes: toList(product.baseNotes),
      tags: searchableTags,
      noteTerms,
      descriptiveText,
      intensityLevel: normalizeIntensity(product.intensity),
      blindBuyLevel: normalizeBlindBuy(product.blindBuy)
    };
  }

  function normalizeIntensity(value) {
    const key = normalizeTerm(toList(value)[0] || value || '');
    return INTENSITY_LEVELS[key] || null;
  }

  function normalizeBlindBuy(value) {
    const key = normalizeTerm(toList(value)[0] || value || '');
    return BLIND_BUY_LEVELS[key] || null;
  }

  function optionByKey(questionId, optionKey) {
    const question = QUESTIONS.find((item) => item.id === questionId);
    return question && question.options.find((option) => option.key === optionKey);
  }

  // Converts selected answers into the scoring buckets used by product ranking.
  function buildProfile(state) {
    const profile = {
      moods: {},
      families: {},
      favoriteNoteGroups: [],
      intensityTarget: null,
      goodFor: {},
      blindBuyTarget: null,
      softAvoids: [],
      dealbreakers: [],
      versatilityBonus: false,
      freeText: {}
    };

    Object.entries(state.answers || {}).forEach(([questionId, selectedKeys]) => {
      selectedKeys.forEach((optionKey) => {
        const option = optionByKey(questionId, optionKey);
        if (!option || !option.scoring) return;
        addMap(profile.moods, option.scoring.moods || {});
        Object.entries(option.scoring.families || {}).forEach(([family, amount]) => {
          const normalizedFamily = normalizeFamily(family);
          profile.families[normalizedFamily] = (profile.families[normalizedFamily] || 0) + Number(amount || 0);
        });
        Object.entries(option.scoring.goodFor || {}).forEach(([occasion, amount]) => {
          const normalizedOccasion = titleCase(normalizeTerm(occasion));
          profile.goodFor[normalizedOccasion] = (profile.goodFor[normalizedOccasion] || 0) + Number(amount || 0);
        });
        if (option.scoring.favoriteNoteGroup) profile.favoriteNoteGroups.push(option.scoring.favoriteNoteGroup);
        if (option.scoring.intensityTarget) profile.intensityTarget = option.scoring.intensityTarget;
        if (option.scoring.blindBuyTarget) profile.blindBuyTarget = option.scoring.blindBuyTarget;
        if (option.scoring.softAvoid) profile.softAvoids.push(option.scoring.softAvoid);
        if (option.scoring.dealbreaker) profile.dealbreakers.push(option.scoring.dealbreaker);
        if (option.scoring.versatilityBonus) profile.versatilityBonus = true;
      });
    });

    profile.favoriteNoteGroups = unique(profile.favoriteNoteGroups);
    profile.softAvoids = unique(profile.softAvoids);
    profile.dealbreakers = unique(profile.dealbreakers);
    profile.freeText = state.freeText || {};
    return profile;
  }

  function cap(value, max) {
    return Math.min(max, Number(value || 0));
  }

  function hasAlias(product, aliases, includeDescription = false) {
    const normalizedAliases = aliases.map(normalizeTerm);
    if (product.noteTerms.some((term) => normalizedAliases.some((alias) => term === alias || term.includes(alias)))) return true;
    return includeDescription && normalizedAliases.some((alias) => product.descriptiveText.includes(alias));
  }

  function aliasHitCount(product, aliases) {
    return aliases.reduce((count, alias) => count + (hasAlias(product, [alias], false) ? 1 : 0), 0);
  }

  function scoreMood(product, profile, strongestMatches) {
    const raw = product.scentMoods.reduce((sum, mood) => sum + (profile.moods[mood] || 0), 0);
    const score = cap(raw, 10);
    if (score > 0) {
      const strongest = product.scentMoods
        .map((mood) => ({ mood, points: profile.moods[mood] || 0 }))
        .sort((a, b) => b.points - a.points)[0];
      if (strongest && strongest.points > 0) strongestMatches.push({ type: 'mood', label: strongest.mood, score });
    }
    return score;
  }

  function scoreFamily(product, profile, strongestMatches) {
    const primaryScore = profile.families[product.primaryFamily] || 0;
    const secondaryScore = product.secondaryFamilies.reduce((sum, family) => sum + ((profile.families[family] || 0) * 0.6), 0);
    const score = cap(primaryScore + secondaryScore, 8);
    if (score > 0) {
      const label = primaryScore > 0 ? product.primaryFamily : product.secondaryFamilies.find((family) => profile.families[family]);
      strongestMatches.push({ type: 'family', label, score });
    }
    return score;
  }

  function scoreNotes(product, profile, strongestMatches) {
    let score = 0;
    profile.favoriteNoteGroups.forEach((groupKey) => {
      const group = NOTE_GROUPS[groupKey];
      if (group && hasAlias(product, group.aliases, false)) {
        score += 2;
        strongestMatches.push({ type: 'note', label: group.label, score: 2 });
      }
    });
    return cap(score, 6);
  }

  function scoreIntensity(product, profile, strongestMatches) {
    if (!profile.intensityTarget || !product.intensityLevel) return 0;
    const diff = Math.abs(product.intensityLevel - profile.intensityTarget);
    const score = diff <= 0.5 ? 4 : diff <= 1 ? 3 : diff <= 1.5 ? 1 : 0;
    if (score > 0) strongestMatches.push({ type: 'intensity', label: 'your preferred intensity', score });
    return score;
  }

  function scoreGoodFor(product, profile, strongestMatches) {
    let score = product.goodFor.reduce((sum, occasion) => sum + (profile.goodFor[occasion] || 0), 0);
    if (profile.versatilityBonus) {
      const coreOccasions = ['Everyday', 'Work', 'Date Night', 'Special Occasion'];
      const coreCount = coreOccasions.filter((occasion) => product.goodFor.includes(occasion)).length;
      if (coreCount >= 3) score += 2;
    }
    score = cap(score, 6);
    if (score > 0) {
      const label = product.goodFor.find((occasion) => profile.goodFor[occasion]) || 'versatile wear';
      strongestMatches.push({ type: 'goodFor', label, score });
    }
    return score;
  }

  function scoreBlindBuy(product, profile, strongestMatches) {
    if (!profile.blindBuyTarget || !product.blindBuyLevel) return 0;
    const diff = Math.abs(product.blindBuyLevel - profile.blindBuyTarget);
    const score = diff === 0 ? 3 : diff === 1 ? 2 : diff === 2 ? 1 : 0;
    if (score > 0) strongestMatches.push({ type: 'blindBuy', label: 'your adventure level', score });
    return score;
  }

  function scoreAvoidance(product, profile) {
    let penalty = 0;
    profile.softAvoids.forEach((avoid) => {
      if (avoid === 'very_sweet' && (product.primaryFamily === 'Gourmand' || /(very sweet|sugary|dessert)/.test(product.descriptiveText))) penalty -= 3;
      if (avoid === 'indolic_florals' && /indolic/.test(product.descriptiveText)) penalty -= 3;
      if (avoid === 'powdery' && /powdery|powdered|\bpowder\b/.test(product.descriptiveText)) penalty -= 3;
      if (avoid === 'smoky_leathery' && hasAlias(product, SOFT_AVOID_ALIASES.smokeLeather, true)) penalty -= 3;
      if (avoid === 'patchouli' && hasAlias(product, ['patchouli'], false)) penalty -= 3;
      if (avoid === 'sharp_citrus' && ['Citrus', 'Fresh'].includes(product.primaryFamily)) penalty -= product.intensityLevel >= 4 ? 3 : 2;
      if (avoid === 'green_herbal') {
        if (['Green', 'Aromatic'].includes(product.primaryFamily)) penalty -= 3;
        else if (product.secondaryFamilies.some((family) => ['Green', 'Aromatic'].includes(family))) penalty -= 1;
      }
      if (avoid === 'heavy_spice' && (product.primaryFamily === 'Spicy' || aliasHitCount(product, NOTE_GROUPS.spices.aliases) >= 2)) penalty -= 3;
      if (avoid === 'fruity') {
        if (product.primaryFamily === 'Fruity') penalty -= 3;
        else if (product.secondaryFamilies.includes('Fruity')) penalty -= 1;
      }
      if (avoid === 'synthetic_base' && hasAlias(product, SOFT_AVOID_ALIASES.syntheticBase, true)) penalty -= 3;
    });
    return Math.max(-6, penalty);
  }

  function getExclusionReasons(product, profile) {
    const reasons = [];
    profile.dealbreakers.forEach((dealbreaker) => {
      if (dealbreaker === 'vanilla' && hasAlias(product, ['vanilla', 'vanilla bean'], false)) reasons.push('vanilla');
      if (dealbreaker === 'rose' && hasAlias(product, ['rose'], false)) reasons.push('rose');
      if (dealbreaker === 'coconut' && hasAlias(product, ['coconut'], false)) reasons.push('coconut');
      if (dealbreaker === 'patchouli' && hasAlias(product, ['patchouli'], false)) reasons.push('patchouli');
      if (dealbreaker === 'leather' && hasAlias(product, ['leather', 'suede'], false)) reasons.push('leather');
      if (dealbreaker === 'tobacco' && hasAlias(product, ['tobacco'], false)) reasons.push('tobacco');
      if (dealbreaker === 'honey' && hasAlias(product, ['honey'], false)) reasons.push('honey');
      if (dealbreaker === 'powdery' && /powdery|powdered|\bpowder\b/.test(product.descriptiveText)) reasons.push('powdery');
      if (dealbreaker === 'smoky' && hasAlias(product, ['smoke', 'smoky', 'cade', 'birch tar'], true)) reasons.push('smoky');
      if (dealbreaker === 'heavy_floral' && ['Floral', 'White Floral', 'Yellow Floral'].includes(product.primaryFamily)) reasons.push('heavy floral');
      if (dealbreaker === 'green_herbal' && (['Green', 'Aromatic'].includes(product.primaryFamily) || /\bgreen\b|herbal|herbaceous/.test(product.descriptiveText))) reasons.push('green/herbal');
      if (dealbreaker === 'fruity' && (product.primaryFamily === 'Fruity' || /dominant(?:ly)? fruity|juicy|fruit-forward|fruit forward/.test(product.descriptiveText))) reasons.push('fruity');
    });
    return unique(reasons);
  }

  function intensityKeyFromValue(value) {
    const key = normalizeTerm(toList(value)[0] || value || '');
    if (key === 'soft-medium' || key === 'soft medium' || key === 'soft-medium') return 'soft-medium';
    return key;
  }

  function buildMatchDetails(product, profile, scores) {
    const matchedMoods = product.scentMoods
      .map((mood) => ({ value: mood, points: Number(profile.moods[mood] || 0) }))
      .filter((match) => match.points > 0)
      .sort((a, b) => b.points - a.points || String(a.value).localeCompare(String(b.value)));

    const matchedFamilies = [];
    const primaryPoints = Number(profile.families[product.primaryFamily] || 0);
    if (primaryPoints > 0) matchedFamilies.push({ value: product.primaryFamily, role: 'primary', points: primaryPoints });
    product.secondaryFamilies.forEach((family) => {
      const points = Number(profile.families[family] || 0) * 0.6;
      if (points > 0) matchedFamilies.push({ value: family, role: 'secondary', points });
    });
    matchedFamilies.sort((a, b) => b.points - a.points || (a.role === 'primary' ? -1 : 1));

    const matchedNoteGroups = profile.favoriteNoteGroups
      .map((groupKey) => {
        const group = NOTE_GROUPS[groupKey];
        if (!group || !hasAlias(product, group.aliases, false)) return null;
        return { key: groupKey, value: group.label, points: 2 };
      })
      .filter(Boolean);

    const matchedGoodFor = product.goodFor
      .map((occasion) => ({ value: occasion, points: Number(profile.goodFor[occasion] || 0) }))
      .filter((match) => match.points > 0)
      .sort((a, b) => b.points - a.points || String(a.value).localeCompare(String(b.value)));

    const productIntensity = intensityKeyFromValue(product.intensity);

    return {
      matchedMoods,
      matchedFamilies,
      matchedNoteGroups,
      matchedGoodFor,
      intensity: profile.intensityTarget && product.intensityLevel ? {
        userTarget: profile.intensityTarget,
        productValue: toList(product.intensity)[0] || productIntensity || '',
        productKey: productIntensity,
        productLevel: product.intensityLevel,
        points: scores.intensityScore
      } : null
    };
  }

  // Scores one normalized product and keeps the breakdown used for explanations.
  function scoreProduct(rawProduct, profile) {
    const product = rawProduct.noteTerms ? rawProduct : normalizeProduct(rawProduct);
    const strongestMatches = [];
    const moodScore = scoreMood(product, profile, strongestMatches);
    const familyScore = scoreFamily(product, profile, strongestMatches);
    const noteScore = scoreNotes(product, profile, strongestMatches);
    const intensityScore = scoreIntensity(product, profile, strongestMatches);
    const goodForScore = scoreGoodFor(product, profile, strongestMatches);
    const blindBuyScore = scoreBlindBuy(product, profile, strongestMatches);
    const avoidancePenalty = scoreAvoidance(product, profile);
    const exclusionReasons = getExclusionReasons(product, profile);
    const total = moodScore + familyScore + noteScore + intensityScore + goodForScore + blindBuyScore + avoidancePenalty;

    const scoredProduct = {
      product,
      total,
      moodScore,
      familyScore,
      noteScore,
      intensityScore,
      goodForScore,
      blindBuyScore,
      avoidancePenalty,
      excluded: exclusionReasons.length > 0,
      exclusionReasons,
      strongestMatches: strongestMatches.sort((a, b) => b.score - a.score).slice(0, 5)
    };

    scoredProduct.matchDetails = buildMatchDetails(product, profile, scoredProduct);
    scoredProduct.whyItMadeTheShelf = whyCopy(scoredProduct);
    return scoredProduct;
  }

  function compareScores(a, b) {
    return b.total - a.total ||
      b.moodScore - a.moodScore ||
      b.familyScore - a.familyScore ||
      b.intensityScore - a.intensityScore ||
      Number(Boolean(b.product.available)) - Number(Boolean(a.product.available)) ||
      String(a.product.title || '').localeCompare(String(b.product.title || '')) ||
      String(a.product.id || '').localeCompare(String(b.product.id || ''));
  }

  function rankProducts(products, profile) {
    const ranked = products.map((product) => scoreProduct(product, profile)).sort(compareScores);
    if (QUIZ_DEBUG || global.SOLVI_QUIZ_DEBUG) {
      console.table(ranked.map((item) => ({
        title: item.product.title,
        total: item.total,
        mood: item.moodScore,
        family: item.familyScore,
        notes: item.noteScore,
        intensityScore: item.intensityScore,
        goodFor: item.goodForScore,
        blindBuy: item.blindBuyScore,
        penalty: item.avoidancePenalty,
        excluded: item.excluded ? item.exclusionReasons.join(', ') : '',
        matchedMoods: (item.matchDetails.matchedMoods || []).map((match) => match.value).join(', '),
        matchedFamilies: (item.matchDetails.matchedFamilies || []).map((match) => `${match.value} (${match.role})`).join(', '),
        intensity: item.matchDetails.intensity ? item.matchDetails.intensity.productValue : '',
        whyItMadeTheShelf: item.whyItMadeTheShelf
      })));
    }
    return ranked;
  }

  function strongestKeys(map) {
    const entries = Object.entries(map || {}).sort((a, b) => b[1] - a[1]);
    return entries.length ? entries.filter((entry) => entry[1] === entries[0][1]).map((entry) => entry[0]) : [];
  }

  function sharesCorePreference(item, profile) {
    const moods = strongestKeys(profile.moods);
    const families = strongestKeys(profile.families);
    return item.product.scentMoods.some((mood) => moods.includes(mood)) ||
      families.includes(item.product.primaryFamily) ||
      item.product.secondaryFamilies.some((family) => families.includes(family));
  }

  function differsFromBest(item, best) {
    if (!item || !best) return false;
    return item.product.primaryFamily !== best.product.primaryFamily ||
      item.product.scentMoods.some((mood) => !best.product.scentMoods.includes(mood));
  }

  function selectResults(ranked, profile) {
    const eligible = ranked.filter((item) => !item.excluded);
    const best = eligible[0] || null;
    if (!best) return { best: null, also: null, plotTwist: null, ranked };

    const also = eligible.find((item) =>
      item.product.id !== best.product.id &&
      item.total >= best.total * 0.7 &&
      sharesCorePreference(item, profile)
    ) || eligible.find((item) => item.product.id !== best.product.id) || null;

    const usedIds = new Set([best.product.id, also && also.product.id].filter(Boolean));
    const plotTwist = eligible.find((item) =>
      !usedIds.has(item.product.id) &&
      item.total >= best.total * 0.55 &&
      sharesCorePreference(item, profile) &&
      differsFromBest(item, best)
    ) || eligible.find((item) => !usedIds.has(item.product.id)) || null;

    return { best, also, plotTwist, ranked };
  }

  function joinHuman(values) {
    const cleanValues = values.filter(Boolean);
    if (cleanValues.length <= 1) return cleanValues[0] || '';
    if (cleanValues.length === 2) return `${cleanValues[0]} and ${cleanValues[1]}`;
    return `${cleanValues.slice(0, -1).join(', ')}, and ${cleanValues[cleanValues.length - 1]}`;
  }

  function stableHash(value) {
    return String(value || '').split('').reduce((hash, character) => {
      return ((hash << 5) - hash + character.charCodeAt(0)) >>> 0;
    }, 0);
  }

  function stableIndex(seed, length) {
    if (!length) return 0;
    return stableHash(seed) % length;
  }

  function stablePick(values, seed) {
    const cleanValues = values.filter(Boolean);
    return cleanValues[stableIndex(seed, cleanValues.length)] || '';
  }

  function familyCopyKey(value) {
    return normalizeTerm(value).replace(/\s+/g, ' ');
  }

  function moodCopyKey(value) {
    return normalizeText(value).replace(/\band\b/g, '&').replace(/\s*&\s*/g, ' & ');
  }

  function familyPhrase(value, seed) {
    const key = familyCopyKey(value);
    return stablePick(FAMILY_COPY[key] || [`your ${normalizeTerm(value) || 'favorite'} scents`], `${seed}:family-copy:${key}`);
  }

  function familyTexture(value, seed) {
    const key = familyCopyKey(value);
    return stablePick(FAMILY_TEXTURE_COPY[key] || [], `${seed}:family-texture:${key}`);
  }

  function moodPhrase(value, seed) {
    const key = moodCopyKey(value);
    return stablePick(MOOD_COPY[key] || [], `${seed}:mood-copy:${key}`);
  }

  function intensityPhrase(value, seed) {
    const key = intensityKeyFromValue(value);
    const phrases = INTENSITY_COPY[key] || [];
    const usablePhrases = phrases.filter((phrase) => phrase.startsWith('with '));
    return stablePick(usablePhrases.length ? usablePhrases : phrases, `${seed}:intensity-copy:${key}`);
  }

  function normalizeDescriptor(value) {
    return normalizeTerm(value).replace(/\bscents?\b/g, '').trim();
  }

  function uniqueCopyParts(values) {
    const seen = new Set();
    return values.filter((value) => {
      const normalized = normalizeDescriptor(value);
      if (!normalized || seen.has(normalized)) return false;
      seen.add(normalized);
      return true;
    });
  }

  function joinCopyParts(values) {
    const cleanValues = uniqueCopyParts(values);
    if (cleanValues.length <= 1) return cleanValues[0] || '';
    if (cleanValues.length === 2) return `${cleanValues[0]} and ${cleanValues[1]}`;
    return `${cleanValues.slice(0, -1).join(', ')} and ${cleanValues[cleanValues.length - 1]}`;
  }

  function notePhrase(noteMatch) {
    return noteMatch && NOTE_GROUP_COPY[noteMatch.key] ? NOTE_GROUP_COPY[noteMatch.key] : '';
  }

  function goodForPhrase(goodForMatch) {
    const key = goodForMatch ? normalizeTerm(goodForMatch.value) : '';
    return GOOD_FOR_COPY[key] || '';
  }

  function withoutYour(value) {
    return String(value || '').replace(/^your\s+/i, '').trim();
  }

  function familyPlainPhrase(value, seed) {
    return withoutYour(familyPhrase(value, seed));
  }

  function familyTaste(value, seed) {
    const key = familyCopyKey(value);
    const taste = FAMILY_TASTE_COPY[key] || {};
    const subject = (taste.subjects || [])[0] || { text: 'something with personality', plural: false };
    return {
      text: subject.text || 'something with personality',
      plural: Boolean(subject.plural),
      concept: taste.concept || 'personality',
      qualities: taste.qualities || [],
      plotQualities: taste.plotQualities || []
    };
  }

  function moodTasteQualities(moodMatches) {
    return (moodMatches || []).flatMap((match) => MOOD_TASTE_COPY[moodCopyKey(match.value)] || []);
  }

  function tasteFeelVerb(taste, still = false) {
    return taste.plural ? `they ${still ? 'still ' : ''}feel` : `it ${still ? 'still ' : ''}feels`;
  }

  function tasteThatFeelVerb(taste) {
    return taste.plural ? 'that still feel' : 'that still feels';
  }

  function tasteQualityParts(taste, moodMatches, fallbackParts = []) {
    return uniqueCopyParts([
      ...(taste.qualities || []),
      ...moodTasteQualities(moodMatches),
      ...fallbackParts
    ]).slice(0, 3);
  }

  function plotQualityParts(taste, qualityParts) {
    return uniqueCopyParts([
      ...(taste.plotQualities || []),
      ...qualityParts,
      'easy to wear'
    ]).slice(0, 3);
  }

  function somethingTastePhrase(qualityParts, fallback) {
    if (fallback && /^something\b/i.test(fallback)) return fallback;
    const cleanParts = uniqueCopyParts(qualityParts).slice(0, 3);
    if (cleanParts.length) return `something ${joinCopyParts(cleanParts)}`;
    return fallback || 'something interesting';
  }

  function leanPhrase(result, seed) {
    const details = result && result.matchDetails ? result.matchDetails : {};
    const familyMatch = (details.matchedFamilies || [])[0];
    const moodMatch = (details.matchedMoods || [])[0];
    const mood = moodMatch ? moodCopyKey(moodMatch.value) : '';
    if (mood.includes('bright')) return 'fresh';
    if (mood.includes('soft')) return 'soft';
    if (mood.includes('dark')) return 'moody';
    if (mood.includes('warm')) return 'warm';
    const familyKey = familyMatch ? familyCopyKey(familyMatch.value) : '';
    if (['fresh', 'citrus', 'fruity', 'aquatic'].includes(familyKey)) return 'fresh';
    if (['musky', 'musk'].includes(familyKey)) return 'soft';
    if (['woody', 'amber', 'spicy', 'earthy'].includes(familyKey)) return 'deeper';
    return stablePick(['classic', 'easy', 'polished'], `${seed}:lean`);
  }

  function copyFacts(result) {
    const details = result.matchDetails || {};
    const familyMatch = (details.matchedFamilies || [])[0];
    const moodMatches = details.matchedMoods || [];
    const strongestMood = moodMatches[0];
    const secondMood = moodMatches[1];
    const noteMatch = (details.matchedNoteGroups || [])[0];
    const goodForMatch = (details.matchedGoodFor || [])[0];
    const seed = [
      result.product && result.product.id,
      familyMatch && familyMatch.value,
      strongestMood && strongestMood.value,
      secondMood && secondMood.value,
      noteMatch && noteMatch.key,
      goodForMatch && goodForMatch.value,
      result.total
    ].filter(Boolean).join(':');
    const family = familyMatch ? familyPhrase(familyMatch.value, seed) : '';
    const familyPlain = familyMatch ? familyPlainPhrase(familyMatch.value, seed) : '';
    const texture = familyMatch ? familyTexture(familyMatch.value, seed) : '';
    const mood = strongestMood ? moodPhrase(strongestMood.value, `${seed}:primary-mood`) : '';
    const secondMoodPhrase = secondMood ? moodPhrase(secondMood.value, `${seed}:second-mood`) : '';
    const taste = familyMatch ? familyTaste(familyMatch.value, seed) : familyTaste('', seed);
    const qualityParts = tasteQualityParts(taste, moodMatches, [texture, mood, secondMoodPhrase]);
    const plotParts = plotQualityParts(taste, qualityParts);
    const usefulNote = result.noteScore >= 2 ? notePhrase(noteMatch) : '';
    const usefulGoodFor = result.goodForScore >= 3 ? goodForPhrase(goodForMatch) : '';
    const usefulIntensity = details.intensity && details.intensity.points >= 4
      ? intensityPhrase(details.intensity.productKey || details.intensity.productValue, seed)
      : '';

    return {
      seed,
      familyMatch,
      strongestMood,
      secondMood,
      moodMatches,
      family,
      familyPlain,
      texture,
      mood,
      secondMoodPhrase,
      taste,
      qualityParts,
      plotParts,
      usefulNote,
      usefulGoodFor,
      usefulIntensity,
      intensityScore: Number(result.intensityScore || 0),
      blindBuyScore: Number(result.blindBuyScore || 0),
      productIntensityLevel: result.product ? Number(result.product.intensityLevel || 0) : 0,
      productBlindBuyLevel: result.product ? Number(result.product.blindBuyLevel || 0) : 0,
      lean: leanPhrase(result, seed)
    };
  }

  function createUsedCopy() {
    return {
      openings: [],
      adjectives: [],
      intensityPhrases: [],
      endings: [],
      concepts: [],
      insights: [],
      primaryLean: ''
    };
  }

  function endingKey(sentence) {
    const words = normalizeTerm(sentence).split(' ').filter(Boolean);
    return words.slice(-7).join(' ');
  }

  function copyCandidate(text, opening, adjectives = [], options = {}) {
    return {
      text: sentenceCaseYou(text),
      opening,
      adjectives: unique(adjectives.map(normalizeDescriptor)),
      insight: options.insight || '',
      score: Number(options.score || 0),
      evidence: unique(options.evidence || []),
      allowRepeatInsight: Boolean(options.allowRepeatInsight),
      intensityPhrase: options.intensityPhrase || '',
      ending: endingKey(text),
      concepts: unique((options.concepts || []).map(normalizeDescriptor))
    };
  }

  function copyPenalty(candidate, usedCopy) {
    let penalty = 0;
    if (usedCopy.openings.includes(candidate.opening)) penalty += 5;
    if (candidate.insight && usedCopy.insights.includes(candidate.insight) && !candidate.allowRepeatInsight) penalty += 7;
    if (candidate.intensityPhrase && usedCopy.intensityPhrases.includes(normalizeTerm(candidate.intensityPhrase))) penalty += 5;
    if (candidate.ending && usedCopy.endings.includes(candidate.ending)) penalty += 3;
    const adjectiveOverlap = candidate.adjectives.filter((adjective) => usedCopy.adjectives.includes(adjective)).length;
    const conceptOverlap = candidate.concepts.filter((concept) => usedCopy.concepts.includes(concept)).length;
    if (adjectiveOverlap >= 2) penalty += 4;
    if (conceptOverlap >= 2) penalty += 2;
    return penalty;
  }

  function rememberCopy(candidate, usedCopy, facts, role) {
    usedCopy.openings.push(candidate.opening);
    usedCopy.adjectives.push(...candidate.adjectives);
    usedCopy.concepts.push(...candidate.concepts);
    usedCopy.endings.push(candidate.ending);
    if (candidate.intensityPhrase) usedCopy.intensityPhrases.push(normalizeTerm(candidate.intensityPhrase));
    if (candidate.insight) usedCopy.insights.push(candidate.insight);
    usedCopy.openings = unique(usedCopy.openings);
    usedCopy.adjectives = unique(usedCopy.adjectives);
    usedCopy.concepts = unique(usedCopy.concepts);
    usedCopy.endings = unique(usedCopy.endings);
    usedCopy.intensityPhrases = unique(usedCopy.intensityPhrases);
    usedCopy.insights = unique(usedCopy.insights);
    if (role === 'main' && !usedCopy.primaryLean) usedCopy.primaryLean = facts.lean;
  }

  function chooseCopyCandidate(candidates, usedCopy, facts, role) {
    const cleanCandidates = candidates.filter((item) => item && item.text && item.text.startsWith('You'));
    if (!cleanCandidates.length) {
      const fallback = copyCandidate(
        'You like scents with enough personality to keep things interesting, and this one earned its spot',
        'fallback',
        ['personality', 'interesting'],
        { insight: 'fallback', evidence: insightEvidence(facts), score: 0 }
      );
      rememberCopy(fallback, usedCopy, facts, role);
      return fallback;
    }
    const selected = cleanCandidates
      .map((candidate, index) => ({ candidate, index, penalty: copyPenalty(candidate, usedCopy) }))
      .sort((a, b) => a.penalty - b.penalty || b.candidate.score - a.candidate.score || a.index - b.index)[0].candidate;
    rememberCopy(selected, usedCopy, facts, role);
    return selected;
  }

  function sentenceCaseYou(sentence) {
    const cleanSentence = String(sentence || '').replace(/\s+/g, ' ').trim();
    if (!cleanSentence) return '';
    return cleanSentence.replace(/[—–]/g, '-').replace(/\.$/, '') + '.';
  }

  function familyKeyFromFacts(facts) {
    return facts.familyMatch ? familyCopyKey(facts.familyMatch.value) : '';
  }

  function moodKeysFromFacts(facts) {
    return [facts.strongestMood, facts.secondMood]
      .filter(Boolean)
      .map((match) => moodCopyKey(match.value));
  }

  function hasMood(facts, fragment) {
    return moodKeysFromFacts(facts).some((key) => key.includes(fragment));
  }

  function hasFamily(facts, keys) {
    return keys.includes(familyKeyFromFacts(facts));
  }

  function insightEvidence(facts, extra = []) {
    return unique([
      ...((facts.moodMatches || []).map((match) => match.value)),
      facts.familyMatch && facts.familyMatch.value,
      facts.usefulIntensity && 'Intensity match',
      facts.usefulGoodFor && facts.usefulGoodFor,
      ...extra
    ].filter(Boolean));
  }

  function insightSignals(facts, usedCopy) {
    const familyKey = familyKeyFromFacts(facts);
    const moodKeys = moodKeysFromFacts(facts);
    const clean = moodKeys.some((key) => key.includes('clean'));
    const bright = moodKeys.some((key) => key.includes('bright'));
    const dark = moodKeys.some((key) => key.includes('dark'));
    const soft = moodKeys.some((key) => key.includes('soft'));
    const warm = moodKeys.some((key) => key.includes('warm'));
    const sweet = moodKeys.some((key) => key.includes('sweet'));
    const freshness = bright || ['fresh', 'citrus', 'aquatic'].includes(familyKey);
    const green = ['green', 'aromatic', 'earthy'].includes(familyKey) || facts.usefulNote.includes('greenery');
    const floral = familyKey === 'floral';
    const sweetness = sweet || ['gourmand', 'fruity'].includes(familyKey);
    const softness = soft || ['musky', 'musk'].includes(familyKey);
    const depth = dark || ['woody', 'amber', 'earthy', 'spicy'].includes(familyKey);
    const warmth = warm || ['amber', 'spicy', 'gourmand'].includes(familyKey);
    const polish = clean || sweet || (facts.usefulGoodFor && /polished|dressed|reservation|plans/.test(facts.usefulGoodFor));
    const weirdness = green || familyKey === 'aromatic' || facts.productBlindBuyLevel >= 3 || facts.blindBuyScore >= 2;
    const boldness = facts.intensityScore >= 3 && facts.productIntensityLevel >= 4;
    const mainLean = usedCopy.primaryLean || facts.lean;

    return {
      familyKey,
      clean,
      bright,
      dark,
      soft,
      warm,
      sweet,
      freshness,
      green,
      floral,
      sweetness,
      softness,
      depth,
      warmth,
      polish,
      weirdness,
      boldness,
      mainLean
    };
  }

  function addInsightCandidate(candidates, facts, insight, score, text, opening, keywords = [], extraEvidence = []) {
    if (score <= 0 || !text) return;
    candidates.push(copyCandidate(text, opening, keywords, {
      insight,
      score,
      evidence: insightEvidence(facts, extraEvidence),
      allowRepeatInsight: insight === 'contrast' && extraEvidence.includes('Plot contrast'),
      concepts: [insight, ...keywords]
    }));
  }

  function buildInsightCandidates(facts, role, usedCopy) {
    const signals = insightSignals(facts, usedCopy);
    const candidates = [];
    const roleBoost = role === 'main' ? 2 : role === 'also' ? 1 : 0;
    const plotBoost = role === 'plot' ? 5 : 0;
    const secondaryBoost = role === 'also' ? 2 : 0;

    if (signals.clean && (signals.green || signals.depth)) {
      addInsightCandidate(candidates, facts, 'contrast', 10 + roleBoost + plotBoost, 'You like your clean scents with a little dirt under their nails', 'You like', ['clean', 'dirt'], ['Clean contrast']);
    }
    if (signals.sweetness && signals.polish) {
      addInsightCandidate(candidates, facts, 'contrast', 9 + roleBoost + plotBoost, 'You want dessert, but you still want it dressed for dinner', 'You want', ['dessert', 'dressed'], ['Sweet contrast']);
    }
    if (signals.dark && signals.softness) {
      addInsightCandidate(candidates, facts, 'contrast', 8 + roleBoost + plotBoost, 'You like your darker scents soft around the edges', 'You like', ['darker', 'soft'], ['Soft darkness']);
    }
    if (signals.freshness && signals.depth) {
      addInsightCandidate(candidates, facts, 'contrast', 8 + roleBoost + plotBoost, 'You want fresh without smelling like you just left the gym', 'You want', ['fresh', 'gym'], ['Fresh contrast']);
    }
    if (signals.warmth && signals.polish) {
      addInsightCandidate(candidates, facts, 'contrast', 7 + roleBoost + plotBoost, 'You like comfort scents that still have somewhere to be', 'You like', ['comfort', 'somewhere'], ['Comfort contrast']);
    }

    addInsightCandidate(candidates, facts, 'freshness', (signals.freshness ? 7 : 0) + secondaryBoost, 'You clearly have a thing for scents that make everything feel a little sunnier', 'You clearly have', ['sunnier']);
    addInsightCandidate(candidates, facts, 'freshness', signals.freshness ? 6 : 0, 'You like freshness with enough personality to keep it out of the gym bag', 'You like', ['freshness', 'personality']);
    addInsightCandidate(candidates, facts, 'freshness', signals.freshness && signals.clean ? 6 : 0, 'You want clean and easy, just never forgettable', 'You want', ['clean', 'forgettable']);

    addInsightCandidate(candidates, facts, 'darkness', signals.depth ? 7 : 0, 'You have a soft spot for scents that behave better after dark', 'You have', ['after dark']);
    addInsightCandidate(candidates, facts, 'darkness', signals.depth ? 6 : 0, 'You like a little mystery without having to work too hard for it', 'You like', ['mystery']);
    addInsightCandidate(candidates, facts, 'darkness', signals.depth ? 6 : 0, 'You like depth, just not the kind that takes itself too seriously', 'You like', ['depth']);

    addInsightCandidate(candidates, facts, 'sweetness', signals.sweetness ? 7 : 0, 'You clearly like your sweet scents with some grown-up supervision', 'You clearly like', ['sweet', 'grown-up']);
    addInsightCandidate(candidates, facts, 'sweetness', signals.sweetness ? 6 : 0, 'You have a weakness for anything delicious that still feels chic', 'You have', ['delicious', 'chic']);
    addInsightCandidate(candidates, facts, 'sweetness', signals.sweetness ? 5 : 0, 'You like a little sweetness more than you may be admitting', 'You like', ['sweetness']);

    addInsightCandidate(candidates, facts, 'softness', signals.softness ? 7 : 0, 'You have a thing for scents that make people come a little closer', 'You have', ['closer']);
    addInsightCandidate(candidates, facts, 'softness', signals.softness ? 6 : 0, 'You like softness that still gives people a reason to remember you', 'You like', ['softness', 'remember']);
    addInsightCandidate(candidates, facts, 'softness', signals.softness ? 5 : 0, 'You clearly appreciate a perfume that knows when to keep its voice down', 'You clearly appreciate', ['voice down']);

    addInsightCandidate(candidates, facts, 'green', signals.green ? 8 : 0, 'You apparently prefer your greenery with some personality', 'You apparently prefer', ['greenery', 'personality']);
    addInsightCandidate(candidates, facts, 'green', signals.green ? 7 : 0, 'You have a soft spot for green things that get a little weird', 'You have', ['green', 'weird']);
    addInsightCandidate(candidates, facts, 'green', signals.green && signals.clean ? 7 : 0, 'You like outdoorsy scents more when they leave the hiking boots at home', 'You like', ['outdoorsy', 'hiking']);

    addInsightCandidate(candidates, facts, 'floral', signals.floral ? 7 : 0, 'You like your flowers much less polite than the average bouquet', 'You like', ['flowers', 'bouquet']);
    addInsightCandidate(candidates, facts, 'floral', signals.floral ? 6 : 0, 'You want petals, just not the garden-party version', 'You want', ['petals']);
    addInsightCandidate(candidates, facts, 'floral', signals.floral ? 5 : 0, 'You like pretty, but only when it comes with a personality', 'You like', ['pretty', 'personality']);

    addInsightCandidate(candidates, facts, 'warmth', signals.warmth ? 8 : 0, 'You clearly have a weakness for scents that feel like staying in on purpose', 'You clearly have', ['staying in']);
    addInsightCandidate(candidates, facts, 'warmth', signals.warmth ? 7 : 0, 'You like warmth when it feels more luxe than sleepy', 'You like', ['warmth', 'luxe']);
    addInsightCandidate(candidates, facts, 'warmth', signals.warmth ? 6 : 0, 'You want cozy, but apparently you still want compliments', 'You want', ['cozy', 'compliments']);

    addInsightCandidate(candidates, facts, 'polish', signals.polish ? 7 : 0, 'You like your easy scents to look like they made an effort', 'You like', ['easy', 'effort']);
    addInsightCandidate(candidates, facts, 'polish', signals.polish ? 6 : 0, 'You like a fragrance that can behave itself and still be fun', 'You like', ['behave', 'fun']);
    addInsightCandidate(candidates, facts, 'polish', signals.polish ? 5 : 0, 'You want put-together without smelling like you planned it', 'You want', ['put-together']);

    addInsightCandidate(candidates, facts, 'weirdness', signals.weirdness ? 8 : 0, 'You clearly are not afraid of a scent with a plot twist of its own', 'You clearly are', ['plot twist']);
    addInsightCandidate(candidates, facts, 'weirdness', signals.weirdness ? 7 : 0, 'You like things familiar enough to wear and strange enough to talk about', 'You like', ['familiar', 'strange']);
    addInsightCandidate(candidates, facts, 'weirdness', signals.weirdness ? 6 : 0, 'You like your scents with at least one questionable decision involved', 'You like', ['questionable']);

    addInsightCandidate(candidates, facts, 'boldness', signals.boldness ? 8 : 0, 'You clearly do not mind your perfume doing a little of the talking', 'You clearly do', ['talking']);
    addInsightCandidate(candidates, facts, 'boldness', signals.boldness ? 7 : 0, 'You like some presence, just not at the expense of the actual scent', 'You like', ['presence']);
    addInsightCandidate(candidates, facts, 'boldness', signals.boldness ? 6 : 0, 'You apparently enjoy a perfume that knows how to make an entrance', 'You apparently enjoy', ['entrance']);

    if (role === 'plot') {
      addInsightCandidate(candidates, facts, 'contrast', ['moody', 'deeper'].includes(signals.mainLean) && signals.freshness ? 14 : 0, 'You might lean moody, but a little sunshine still gets you when it has enough depth', 'You might lean', ['moody', 'sunshine'], ['Plot contrast']);
      addInsightCandidate(candidates, facts, 'contrast', ['fresh', 'classic', 'polished'].includes(signals.mainLean) && (signals.warmth || signals.depth) ? 13 : 0, 'You usually play it clean, but apparently something richer can still turn your head', 'You usually play', ['clean', 'richer'], ['Plot contrast']);
      addInsightCandidate(candidates, facts, 'contrast', signals.mainLean === 'soft' && signals.boldness ? 13 : 0, 'You like things soft, but sometimes the perfume can do the talking', 'You like', ['soft', 'talking'], ['Plot contrast']);
      addInsightCandidate(candidates, facts, 'contrast', signals.mainLean === 'warm' && signals.freshness ? 12 : 0, 'You may love cozy, but something brighter clearly still knows your name', 'You may love', ['cozy', 'brighter'], ['Plot contrast']);
      addInsightCandidate(candidates, facts, 'weirdness', signals.weirdness ? 11 : 0, 'You may love an easy scent, but you are clearly not afraid of a little weirdness', 'You may love', ['easy', 'weirdness'], ['Plot adventure']);
    }

    return candidates;
  }

  function whyCopy(result, role = 'main', usedCopy = createUsedCopy()) {
    if (!result) return '';
    const facts = copyFacts(result);
    const selected = chooseCopyCandidate(buildInsightCandidates(facts, role, usedCopy), usedCopy, facts, role);
    const debug = {
      productTitle: result.product && result.product.title,
      resultRole: role,
      selectedInsight: selected.insight || 'fallback',
      evidenceUsed: selected.evidence || insightEvidence(facts),
      whyItMadeTheShelf: selected.text
    };
    result.whyItMadeTheShelfDebug = debug;
    return selected.text;
  }

  function assignResultExplanations(results) {
    const usedCopy = createUsedCopy();
    [
      ['best', 'main'],
      ['also', 'also'],
      ['plotTwist', 'plot']
    ].forEach(([key, role]) => {
      if (!results[key]) return;
      results[key].whyItMadeTheShelf = whyCopy(results[key], role, usedCopy);
    });
    return results;
  }

  function resultDebugSummary(result) {
    if (!result) return null;
    const details = result.matchDetails || {};
    const copyDebug = result.whyItMadeTheShelfDebug || {};
    return {
      productTitle: copyDebug.productTitle || (result.product && result.product.title),
      resultRole: copyDebug.resultRole || '',
      selectedInsight: copyDebug.selectedInsight || '',
      evidenceUsed: copyDebug.evidenceUsed || [],
      whyItMadeTheShelf: copyDebug.whyItMadeTheShelf || result.whyItMadeTheShelf || whyCopy(result),
      title: result.product && result.product.title,
      total: result.total,
      matchedMoods: details.matchedMoods || [],
      matchedFamilies: details.matchedFamilies || [],
      intensity: details.intensity || null
    };
  }

  function parseProductPayload(root) {
    const script = root.querySelector('[data-solvi-quiz-products]');
    if (!script) return { products: [], meta: { isTruncated: true } };
    try {
      return parseProductScript(script);
    } catch (error) {
      if (global.console) console.warn('Solvi quiz product JSON could not be parsed.', error);
      return { products: [], meta: { isTruncated: true, loadError: error.message } };
    }
  }

  function parseProductScript(script, context = {}) {
    try {
      const payload = JSON.parse(script.textContent || '{}');
      return {
        products: (payload.products || []).map(normalizeProduct),
        meta: payload
      };
    } catch (error) {
      error.quizLoaderDebug = { ...context, errorMessage: error.message };
      throw error;
    }
  }

  function parseProductPageHtml(html, context = {}) {
    if (!global.DOMParser) throw new Error('Product page parser unavailable.');
    const doc = new global.DOMParser().parseFromString(html, 'text/html');
    const script = doc.querySelector('[data-quiz-product-page]');
    if (!script) {
      const error = new Error(`Quiz product JSON not found on page ${context.page || 'unknown'}`);
      error.quizLoaderDebug = context;
      throw error;
    }
    return parseProductScript(script, context);
  }

  function dedupeProducts(products) {
    const productMap = new Map();
    const skipped = [];

    products.forEach((product) => {
      const id = product && product.id ? String(product.id) : '';
      if (!id) {
        skipped.push({ title: product && product.title ? product.title : 'Untitled product', reason: 'missing product ID' });
        return;
      }
      if (productMap.has(id)) {
        skipped.push({ id, title: product.title || productMap.get(id).title || 'Duplicate product', reason: 'duplicate product ID' });
        return;
      }
      productMap.set(id, product);
    });

    return { products: Array.from(productMap.values()), skipped };
  }

  function buildCollectionUrl(collectionUrl, collectionHandle) {
    const shopRoot = global.Shopify && global.Shopify.routes && global.Shopify.routes.root ? global.Shopify.routes.root : '/';
    const basePath = shopRoot.endsWith('/') ? shopRoot.slice(0, -1) : shopRoot;
    const safeHandle = collectionHandle === 'all-perfume' ? 'all' : collectionHandle;
    const safeCollectionUrl = collectionUrl && /\/collections\/all-perfume(?:[/?#]|$)/.test(collectionUrl)
      ? collectionUrl.replace('/collections/all-perfume', '/collections/all')
      : collectionUrl;
    if (safeCollectionUrl) {
      if (/^https?:\/\//.test(safeCollectionUrl)) return safeCollectionUrl;
      const path = safeCollectionUrl.startsWith('/') ? safeCollectionUrl : `/${safeCollectionUrl}`;
      if (basePath && path.startsWith(`${basePath}/`)) return path;
      return `${basePath}${path}`;
    }
    return `${basePath}/collections/${encodeURIComponent(safeHandle || 'all')}`;
  }

  function withQuery(url, params) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${params}`;
  }

  function logProductLoaderDebug(debug) {
    if (!global.console || !(QUIZ_DEBUG || global.SOLVI_QUIZ_DEBUG)) return;
    global.console.group('[Solvi Quiz] product loader');
    global.console.log('collection URL', debug.collectionUrl);
    global.console.log('requested page', debug.page);
    global.console.log('request URL', debug.url);
    global.console.log('response status', debug.status);
    global.console.log('response content type', debug.contentType);
    global.console.log('first 300 chars', debug.htmlSnippet);
    if (debug.collectionWarning) global.console.log('collection warning', debug.collectionWarning);
    if (debug.errorMessage) global.console.log('error', debug.errorMessage);
    if (typeof debug.expected !== 'undefined' || typeof debug.loaded !== 'undefined') {
      global.console.log('counts', { expected: debug.expected, loaded: debug.loaded });
    }
    global.console.groupEnd();
  }

  async function fetchProductPage(collectionUrl, sectionId, page, collectionHandle) {
    const collectionPageUrl = buildCollectionUrl(collectionUrl, collectionHandle);
    const id = sectionId || 'solvi-quiz-product-data';
    const url = withQuery(collectionPageUrl, `page=${encodeURIComponent(page)}&section_id=${encodeURIComponent(id)}`);
    let lastError;

    for (let attempt = 0; attempt < 2; attempt += 1) {
      const debug = {
        collectionUrl: collectionPageUrl,
        page,
        url,
        status: null,
        contentType: '',
        htmlSnippet: ''
      };

      try {
        const response = await global.fetch(url, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        debug.status = response.status;
        debug.contentType = response.headers.get('content-type') || '';
        const html = await response.text();
        debug.htmlSnippet = html.slice(0, 300);
        if (!response.ok) {
          const error = new Error(`Quiz product page ${page} returned ${response.status}`);
          error.quizLoaderDebug = debug;
          throw error;
        }
        const payload = parseProductPageHtml(html, debug);
        debug.productCount = payload.products.length;
        if (!payload.meta.collectionHandle && !payload.products.length) {
          const error = new Error(`Quiz product page ${page} did not render a collection context.`);
          error.quizLoaderDebug = { ...debug, errorMessage: error.message };
          throw error;
        }
        if (!payload.meta.collectionHandle) debug.collectionWarning = 'Collection handle missing, but products rendered.';
        logProductLoaderDebug(debug);
        return payload;
      } catch (error) {
        error.quizLoaderDebug = error.quizLoaderDebug || { ...debug, errorMessage: error.message };
        error.quizLoaderDebug.errorMessage = error.message;
        logProductLoaderDebug(error.quizLoaderDebug);
        lastError = error;
      }
    }

    throw lastError;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[char]));
  }

  // Keeps the existing quiz screens, nav, and result areas while swapping in live logic.
  class SolviQuizShell {
    constructor(root) {
      if (!root || root.dataset.quizReady === 'true') return;
      root.dataset.quizReady = 'true';
      this.root = root;
      this.intro = root.querySelector('[data-quiz-intro]');
      this.questionScreen = root.querySelector('[data-quiz-questions]');
      this.resultsScreen = root.querySelector('[data-quiz-results]');
      this.mount = root.querySelector('[data-quiz-question-mount]');
      this.progressText = root.querySelector('[data-quiz-progress-text]');
      this.progressBar = root.querySelector('[data-quiz-progress-bar]');
      this.progressTrack = root.querySelector('[role="progressbar"]');
      this.backButton = root.querySelector('[data-quiz-back]');
      this.nextButton = root.querySelector('[data-quiz-next]');
      this.note = root.querySelector('[data-selection-note]');
      const payload = parseProductPayload(root);
      this.initialProductPayload = payload;
      this.products = payload.products;
      this.productMeta = payload.meta;
      this.productLoadPromise = null;
      this.productLoadError = null;
      this.lastScoreSummary = null;
      this.resultRequestId = 0;
      this.latestResults = [];
      this.activePath = '';
      this.activeQuestions = [];
      this.currentIndex = 0;
      this.state = { path: '', answers: {}, freeText: {} };
      this.bind();
      this.applyRequestedStart();
    }

    bind() {
      this.root.addEventListener('click', (event) => {
        const samplePicksLink = event.target.closest('[data-quiz-sample-picks]');
        if (samplePicksLink && this.root.contains(samplePicksLink)) {
          event.preventDefault();
          this.addSamplePicksToCart(samplePicksLink);
          return;
        }

        const pathButton = event.target.closest('[data-quiz-path]');
        if (pathButton && this.root.contains(pathButton)) {
          this.startPath(pathButton.dataset.quizPath);
          return;
        }

        const answer = event.target.closest('[data-quiz-answer-key]');
        if (answer && this.root.contains(answer)) {
          this.toggleAnswer(answer);
          return;
        }

        if (event.target.closest('[data-quiz-back]')) this.goBack();
        if (event.target.closest('[data-quiz-next]')) this.goNext();
        if (event.target.closest('[data-quiz-retry]')) this.retryResults();
        if (event.target.closest('[data-quiz-restart]')) this.restart();
        if (event.target.closest('[data-quiz-save-all]')) this.saveAllToShelf();
      });

      this.root.addEventListener('input', (event) => {
        const input = event.target.closest('[data-quiz-free-text]');
        if (!input) return;
        const questionId = input.dataset.questionId;
        const optionKey = input.dataset.optionKey;
        this.state.freeText[`${questionId}:${optionKey}`] = input.value;
      });
    }

    applyRequestedStart() {
      const params = new URLSearchParams(global.location?.search || '');
      const requestedPath = PATH_ALIASES[params.get('path')] || params.get('path') || '';
      const freshValue = String(params.get('fresh') || '').toLowerCase();
      const shouldStartFresh = ['1', 'true', 'yes'].includes(freshValue);

      if (shouldStartFresh) {
        if (requestedPath) this.startPath(requestedPath);
        else this.restart();
        return;
      }

      this.restoreCompletedResult();
    }

    restoreCompletedResult() {
      let saved;
      try {
        saved = JSON.parse(global.localStorage.getItem(QUIZ_RESULT_STORAGE_KEY) || 'null');
      } catch (error) {
        saved = null;
      }
      const recommendations = Array.isArray(saved?.recommendations) ? saved.recommendations.slice(0, 3) : [];
      if (!recommendations.length) return;

      this.state.path = saved.path || '';
      this.latestResults = recommendations.map((recommendation) => ({
        product: {
          id: recommendation.productId || null,
          handle: recommendation.handle || '',
          sampleVariantId: recommendation.variantId || null,
wishlistVariantId: recommendation.wishlistVariantId || null,
          title: recommendation.title || 'Solvi scent',
          url: recommendation.url || `/products/${encodeURIComponent(recommendation.handle || '')}`,
          vendor: recommendation.vendor || '',
          featuredImage: recommendation.featuredImage || '',
          primaryFamily: recommendation.primaryFamily || '',
          scentMoods: Array.isArray(recommendation.scentMoods) ? recommendation.scentMoods : []
        },
        whyItMadeTheShelf: recommendation.reason || ''
      }));

      this.setResultCardsMode('results');
      this.renderResult('[data-main-result]', this.latestResults[0]);
      this.renderResult('[data-secondary-result]', this.latestResults[1]);
      this.renderResult('[data-tertiary-result]', this.latestResults[2]);
      this.updateSamplePicksLink();
      this.showScreen('results');
    }

    startPath(path) {
      this.activePath = PATH_ALIASES[path] || path;
      this.state = { path: this.activePath, answers: {}, freeText: {} };
      this.activeQuestions = QUESTIONS.filter((question) => question.path === 'both' || question.path === this.activePath);
      if (!this.activeQuestions.length) {
        this.activePath = 'curious';
        this.state.path = this.activePath;
        this.activeQuestions = QUESTIONS.filter((question) => question.path === 'both' || question.path === this.activePath);
      }
      this.currentIndex = 0;
      this.renderQuestion();
      this.showScreen('questions');
    }

    showScreen(name) {
      if (this.intro) this.intro.hidden = name !== 'intro';
      if (this.questionScreen) this.questionScreen.hidden = name !== 'questions';
      if (this.resultsScreen) this.resultsScreen.hidden = name !== 'results';
    }

    renderQuestion() {
      const current = this.activeQuestions[this.currentIndex];
      if (!current || !this.mount) return;
      this.mount.innerHTML = this.renderQuestionMarkup(current);

      const selectedKeys = this.state.answers[current.id] || [];
      selectedKeys.forEach((key) => {
        const button = Array.from(this.mount.querySelectorAll('[data-quiz-answer-key]')).find((item) => item.dataset.quizAnswerKey === key);
        if (button) button.setAttribute('aria-pressed', 'true');
      });
      this.renderFreeTextInputs(current);
      this.updateProgress();
      this.updateNextState();
      this.setNote('');

      const heading = this.mount.querySelector('h2');
      if (heading) heading.focus({ preventScroll: false });
    }

    renderQuestionMarkup(question) {
      return `
        <article class="solvi-quiz-shell__question" data-quiz-question data-question-id="${escapeHtml(question.id)}" data-selection-type="${escapeHtml(question.type)}">
          <div class="solvi-quiz-shell__question-head">
            <p class="solvi-quiz-shell__question-number">${escapeHtml(question.kicker || '')}</p>
            <h2 id="SolviQuizQuestion-${escapeHtml(question.id)}" tabindex="-1">${escapeHtml(question.title)}</h2>
            ${question.helper ? `<p class="solvi-quiz-shell__question-helper">${escapeHtml(question.helper)}</p>` : ''}
          </div>
          <div class="solvi-quiz-shell__answers" role="group" aria-labelledby="SolviQuizQuestion-${escapeHtml(question.id)}">
            ${question.options.map((option) => `
              <button class="solvi-quiz-shell__answer" type="button" aria-pressed="false" data-quiz-answer-key="${escapeHtml(option.key)}">
                <span>
                  <span class="solvi-quiz-shell__answer-label">${escapeHtml(option.label)}</span>
                  ${option.description ? `<small>${escapeHtml(option.description)}</small>` : ''}
                </span>
              </button>
            `).join('')}
          </div>
          <div class="solvi-quiz-shell__free-text-wrap" data-quiz-free-text-wrap></div>
        </article>
      `;
    }

    renderFreeTextInputs(question) {
      const wrap = this.mount.querySelector('[data-quiz-free-text-wrap]');
      if (!wrap) return;
      const selectedKeys = this.state.answers[question.id] || [];
      wrap.innerHTML = selectedKeys.map((optionKey) => {
        const option = question.options.find((item) => item.key === optionKey);
        if (!option || !option.freeText) return '';
        const id = `SolviQuizFreeText-${question.id}-${option.key}`;
        const value = this.state.freeText[`${question.id}:${option.key}`] || '';
        return `
          <label class="solvi-quiz-shell__free-text" for="${escapeHtml(id)}">
            <span>${escapeHtml(option.label)}</span>
            <input id="${escapeHtml(id)}" type="text" value="${escapeHtml(value)}" placeholder="Type it here, if you want" data-quiz-free-text data-question-id="${escapeHtml(question.id)}" data-option-key="${escapeHtml(option.key)}">
          </label>
        `;
      }).join('');
    }

    updateProgress() {
      const total = this.activeQuestions.length;
      const position = this.currentIndex + 1;
      if (this.progressText) this.progressText.textContent = `${position} / ${total}`;
      const progress = Math.round((position / total) * 100);
      if (this.progressBar) this.progressBar.style.width = `${progress}%`;
      if (this.progressTrack) this.progressTrack.setAttribute('aria-valuenow', String(progress));
      const firstQuestionBackLabel = (this.root.dataset.pathBackLabel || '').trim().toLowerCase() === 'paths'
        ? 'start over'
        : (this.root.dataset.pathBackLabel || 'start over');
      if (this.backButton) this.backButton.textContent = this.currentIndex === 0 ? firstQuestionBackLabel : this.root.dataset.backLabel;
      if (this.nextButton) this.nextButton.textContent = position === total ? this.root.dataset.resultsLabel : this.root.dataset.nextLabel;
    }

    toggleAnswer(button) {
      const current = this.activeQuestions[this.currentIndex];
      if (!current) return;
      const optionKey = button.dataset.quizAnswerKey;
      const option = current.options.find((item) => item.key === optionKey);
      const selected = [...(this.state.answers[current.id] || [])];
      const alreadySelected = selected.includes(optionKey);

      if (current.type === 'single') {
        this.state.answers[current.id] = alreadySelected ? [] : [optionKey];
      } else if (alreadySelected) {
        this.state.answers[current.id] = selected.filter((key) => key !== optionKey);
      } else {
        const nextSelected = this.resolveExclusiveSelection(current, option, selected);
        if (current.maxSelections && nextSelected.length >= current.maxSelections) {
          this.setNote(`Choose up to ${current.maxSelections}. Remove one to change your picks.`);
          return;
        }
        this.state.answers[current.id] = [...nextSelected, optionKey];
      }

      this.mount.querySelectorAll('[data-quiz-answer-key]').forEach((answer) => {
        const isPressed = (this.state.answers[current.id] || []).includes(answer.dataset.quizAnswerKey);
        answer.setAttribute('aria-pressed', String(isPressed));
      });
      this.renderFreeTextInputs(current);
      this.setNote('');
      this.updateNextState();
    }

    resolveExclusiveSelection(question, option, selected) {
      if (!option || !option.exclusiveGroup) {
        return selected.filter((key) => {
          const selectedOption = question.options.find((item) => item.key === key);
          return !selectedOption || !selectedOption.exclusiveGroup;
        });
      }
      return [];
    }

    updateNextState() {
      const current = this.activeQuestions[this.currentIndex];
      if (!current || !this.nextButton) return;
      this.nextButton.disabled = !(this.state.answers[current.id] || []).length;
    }

    goBack() {
      if (this.currentIndex === 0) {
        this.showScreen('intro');
        const introHeading = this.intro && this.intro.querySelector('[data-intro-heading]');
        if (introHeading) introHeading.focus({ preventScroll: false });
        return;
      }
      this.currentIndex -= 1;
      this.renderQuestion();
    }

    goNext() {
      if (this.nextButton && this.nextButton.disabled) return;
      if (this.currentIndex < this.activeQuestions.length - 1) {
        this.currentIndex += 1;
        this.renderQuestion();
        return;
      }
      this.showResults();
    }

    async showResults() {
      const requestId = this.resultRequestId + 1;
      this.resultRequestId = requestId;
      this.renderLoadingState();
      this.showScreen('results');
      const heading = this.resultsScreen && this.resultsScreen.querySelector('[data-results-heading]');
      if (heading) heading.focus({ preventScroll: false });

      try {
        await this.loadAllProducts();
      } catch (error) {
        if (requestId !== this.resultRequestId) return;
        this.productLoadError = error;
        if (global.console && global.SOLVI_QUIZ_DEBUG) console.warn('Solvi quiz product data could not be fully loaded.', error);
        this.renderRetryState();
        return;
      }
      if (requestId !== this.resultRequestId) return;

      const profile = buildProfile(this.state);
      const ranked = rankProducts(this.products, profile);
      const results = assignResultExplanations(selectResults(ranked, profile));
      this.setResultCardsMode('results');
      this.lastScoreSummary = {
        totalProducts: Number(this.productMeta.totalProducts || this.products.length),
        loadedProducts: this.products.length,
        scoredProducts: ranked.length,
        skippedProducts: this.productMeta.skippedProducts || [],
        results: {
          best: results.best || null,
          also: results.also || null,
          plotTwist: results.plotTwist || null
        }
      };
      if (QUIZ_DEBUG || global.SOLVI_QUIZ_DEBUG) {
        this.lastScoreSummary.debugResults = {
          best: resultDebugSummary(results.best),
          also: resultDebugSummary(results.also),
          plotTwist: resultDebugSummary(results.plotTwist)
        };
      }
      global.SolviQuizLastRun = this.lastScoreSummary;
      this.latestResults = [results.best, results.also, results.plotTwist].filter(Boolean);
      this.persistResults();
      this.renderResult('[data-main-result]', results.best);
      this.renderResult('[data-secondary-result]', results.also);
      this.renderResult('[data-tertiary-result]', results.plotTwist);
      this.updateSamplePicksLink();
    }

    persistResults() {
      const recommendations = this.latestResults.slice(0, 3).map((result) => ({
        handle: result.product.handle,
        productId: result.product.id,
        variantId: result.product.sampleVariantId || null,
wishlistVariantId: result.product.wishlistVariantId || null,
        title: result.product.title,
        url: new URL(result.product.url, global.location.origin).href,
        vendor: result.product.vendor || '',
        featuredImage: result.product.featuredImage || '',
        primaryFamily: result.product.primaryFamily || '',
        scentMoods: result.product.scentMoods || [],
        reason: result.whyItMadeTheShelf || whyCopy(result)
      }));
      try {
        global.localStorage.setItem(QUIZ_RESULT_STORAGE_KEY, JSON.stringify({
          path: this.state.path,
          completedAt: new Date().toISOString(),
          recommendations
        }));
      } catch (error) {
        if (QUIZ_DEBUG) global.console?.warn('Could not save Solvi quiz result.', error);
      }
    }

    updateSamplePicksLink() {
      const link = this.root.querySelector('[data-quiz-sample-picks]');
      if (!link) return;
      link.href = '/cart';
    }

    isEligibleSampleVariant(variant) {
      if (!variant || variant.available === false) return false;
      const title = String(variant.title || variant.name || '').toLowerCase().trim();
      const size = title.replace(/\(sample\)/g, '').trim();
      return title.includes('sample') || ['1.5ml', '1.8ml', '2ml', '3ml', '3.5ml', '5ml'].includes(size);
    }

    async resolveSampleVariant(result, rootUrl) {
      const product = result?.product || {};
      const handle = String(product.handle || '').trim();

      if (handle) {
        try {
          const response = await global.fetch(`${rootUrl}products/${encodeURIComponent(handle)}.js`, {
            headers: { Accept: 'application/json' }
          });
          if (response.ok) {
            const liveProduct = await response.json();
            const liveVariant = (liveProduct.variants || []).find((variant) => this.isEligibleSampleVariant(variant));
            return liveVariant ? Number.parseInt(liveVariant.id, 10) : null;
          }
        } catch (error) {
          // Fall back to the quiz payload if the live product lookup is unavailable.
        }
      }

      const payloadProduct = this.products.find((item) =>
        (handle && item.handle === handle) || (product.id && String(item.id) === String(product.id))
      );
      return Number.parseInt(payloadProduct?.sampleVariantId || product.sampleVariantId, 10) || null;
    }

    async addSamplePicksToCart(link) {
      if (this.addingSamplePicks) return;
      const status = this.root.querySelector('[data-quiz-save-status]');

      this.addingSamplePicks = true;
      const originalLabel = link.textContent;
      link.setAttribute('aria-disabled', 'true');
      link.textContent = 'adding samples…';
      if (status) status.textContent = '';

      try {
        const shopRoot = global.Shopify?.routes?.root || '/';
        const rootUrl = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
        const results = this.latestResults.slice(0, 3);
        const resolvedVariantIds = await Promise.all(results.map((result) => this.resolveSampleVariant(result, rootUrl)));
        const uniqueVariantIds = Array.from(new Set(resolvedVariantIds.filter(Boolean)));
        let unavailableCount = resolvedVariantIds.filter((variantId) => !variantId).length;
        let addedCount = 0;

        for (const variantId of uniqueVariantIds) {
          const response = await global.fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: 1,
                properties: {
                  '_Solvi sample bag': 'Yes',
                  '_Quiz pick': 'Yes'
                }
              }]
            })
          });

          if (response.ok) addedCount += 1;
          else unavailableCount += 1;
        }

        await global.fetch(`${rootUrl}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: { '_Solvi quiz unavailable picks': String(unavailableCount) }
          })
        }).catch(() => null);

        if (!addedCount && !unavailableCount) throw new Error('We could not find sample sizes for these matches.');
        global.location.assign(`${rootUrl}cart`);
      } catch (error) {
        if (status) status.textContent = error.message || 'We could not add those samples. Please try again.';
        link.textContent = originalLabel;
        link.removeAttribute('aria-disabled');
        this.addingSamplePicks = false;
      }
    }

    saveAllToShelf() {
  const button = this.root.querySelector('[data-quiz-save-all]');
  const status = this.root.querySelector('[data-quiz-save-status]');

  if (button?.dataset.shelfSaved === 'true') {
    global.location.href = '/pages/swym-wishlist';
    return;
  }

  const products = this.latestResults
    .map((result) => result?.product)
    .filter((product) =>
      product &&
      product.id &&
      product.url &&
      product.wishlistVariantId
    );

  if (!products.length) {
    if (status) status.textContent = 'We could not find these scents for your shelf.';
    return;
  }

  if (button) {
    button.disabled = true;
    button.textContent = 'saving to your shelf…';
  }

  if (status) status.textContent = '';

  global.SwymCallbacks = global.SwymCallbacks || [];

  global.SwymCallbacks.push((swat) => {
    const normalizeItems = (response) => {
      if (Array.isArray(response)) return response;
      if (Array.isArray(response?.items)) return response.items;
      if (Array.isArray(response?.products)) return response.products;
      return [];
    };

    const finish = (successCount) => {
      if (button) {
        button.disabled = false;

        if (successCount > 0) {
          button.dataset.shelfSaved = 'true';
          button.textContent = 'view my scent shelf →';
        } else {
          button.textContent = 'save all to my shelf';
        }
      }

      if (status) {
        status.textContent = successCount > 0
          ? 'saved to your shelf ✓'
          : 'We could not update your shelf. Please try again.';
      }
    };

    const saveProducts = (existingItems = []) => {
      let finished = 0;
      let successes = 0;

      const done = (ok) => {
        finished += 1;
        if (ok) successes += 1;

        if (finished === products.length) {
          finish(successes);
        }
      };

      products.forEach((product) => {
        const empi = String(product.id);
        const epi = String(product.wishlistVariantId);

        const alreadySaved = existingItems.some(
          (item) =>
            String(item?.empi || '') === empi &&
            String(item?.epi || '') === epi
        );

        if (alreadySaved) {
          done(true);
          return;
        }

        const payload = {
          empi: Number(product.id),
          epi: Number(product.wishlistVariantId),
          du: new URL(product.url, global.location.origin).href
        };

        if (product.title) payload.dt = product.title;
        if (product.featuredImage) payload.iu = product.featuredImage;

        try {
          swat.addToWishList(
            payload,
            () => done(true),
            () => done(false)
          );
        } catch (error) {
          done(false);
        }
      });
    };

    if (typeof swat.fetch === 'function') {
      try {
        swat.fetch(
          (response) => saveProducts(normalizeItems(response)),
          () => saveProducts([])
        );
      } catch (error) {
        saveProducts([]);
      }
    } else {
      saveProducts([]);
    }
  });
}

    loadAllProducts() {
      if (this.productLoadPromise) return this.productLoadPromise;
      this.productLoadPromise = this.loadAllProductsNow().catch((error) => {
        this.productLoadPromise = null;
        throw error;
      });
      return this.productLoadPromise;
    }

    async loadAllProductsNow() {
      const initialPayload = this.initialProductPayload || { products: [], meta: {} };
      const rawCollectionHandle = this.root.dataset.productCollectionHandle || initialPayload.meta.collectionHandle || 'all';
      const collectionHandle = rawCollectionHandle === 'all-perfume' ? 'all' : rawCollectionHandle;
      const collectionUrl = this.root.dataset.productCollectionUrl || initialPayload.meta.collectionUrl || '';
      const sectionId = this.root.dataset.productSectionId || 'solvi-quiz-product-data';
      const firstPagePayload = await fetchProductPage(collectionUrl, sectionId, 1, collectionHandle);
      const firstMeta = firstPagePayload.meta || {};
      const totalProducts = Number(firstMeta.total || firstMeta.totalProducts || 0);
      const totalPages = Number(firstMeta.pages || 1);
      const allProducts = [...(firstPagePayload.products || [])];
      let latestMeta = firstMeta;
      const seenPages = new Set([String(Number(firstMeta.currentPage || 1))]);

      for (let page = 2; page <= totalPages; page += 1) {
        let pagePayload;
        try {
          pagePayload = await fetchProductPage(collectionUrl, sectionId, page, collectionHandle);
        } catch (error) {
          error.quizLoaderDebug = {
            ...(error.quizLoaderDebug || {}),
            expected: totalProducts,
            loaded: allProducts.length,
            failedPage: page
          };
          throw error;
        }
        latestMeta = pagePayload.meta || {};
        const currentPage = Number(latestMeta.currentPage || page);
        if (seenPages.has(String(currentPage))) {
          const error = new Error(`Quiz product page ${page} repeated page ${currentPage}.`);
          error.quizLoaderDebug = {
            collectionUrl: buildCollectionUrl(collectionUrl, collectionHandle),
            page,
            status: 'duplicate page',
            expected: totalProducts,
            loaded: allProducts.length,
            failedPage: page,
            errorMessage: error.message
          };
          throw error;
        }
        seenPages.add(String(currentPage));
        allProducts.push(...(pagePayload.products || []));
      }

      const deduped = dedupeProducts(allProducts);
      if (global.console && (QUIZ_DEBUG || global.SOLVI_QUIZ_DEBUG)) {
        global.console.log({
          expected: totalProducts,
          loaded: deduped.products.length
        });
        if (deduped.skipped.length) global.console.log('[Solvi Quiz] duplicate product IDs after combining pages', deduped.skipped);
      }
      if (totalProducts && deduped.products.length !== totalProducts) {
        const error = new Error(`Loaded ${deduped.products.length} of ${totalProducts} quiz products.`);
        error.quizLoaderDebug = {
          collectionUrl: buildCollectionUrl(collectionUrl, collectionHandle),
          page: 'verification',
          status: 'count mismatch',
          expected: totalProducts,
          loaded: deduped.products.length,
          failedPage: '',
          errorMessage: error.message
        };
        throw error;
      }

      this.products = deduped.products;
      this.productMeta = {
        ...firstMeta,
        ...latestMeta,
        totalProducts,
        loadedProducts: deduped.products.length,
        serializedProducts: allProducts.length,
        pageCount: totalPages,
        collectionUrl: buildCollectionUrl(collectionUrl, collectionHandle),
        skippedProducts: deduped.skipped,
        isTruncated: false,
        hasNextPage: false
      };
      return this.products;
    }

    renderLoadingState() {
      this.setResultCardsMode('single');
      this.root.querySelectorAll('[data-main-result], [data-secondary-result], [data-tertiary-result]').forEach((target, index) => {
        target.innerHTML = index === 0 ? `
          <div class="solvi-quiz-shell__result-inner">
            <h3>Finding your shelf…</h3>
            <div class="rte"><p>One sec while we check the full Solvi shelf.</p></div>
          </div>
        ` : '';
      });
    }

    renderRetryState() {
      this.setResultCardsMode('single');
      const debug = this.productLoadError && this.productLoadError.quizLoaderDebug ? this.productLoadError.quizLoaderDebug : {};
      const debugMarkup = (QUIZ_DEBUG || global.SOLVI_QUIZ_DEBUG) ? `
        <small class="solvi-quiz-shell__debug">
          expected: ${escapeHtml(debug.expected || this.productMeta.totalProducts || '') || 'unknown'} ·
          loaded: ${escapeHtml(debug.loaded || this.productMeta.loadedProducts || this.products.length || 0)} ·
          failed page: ${escapeHtml(debug.failedPage || debug.page || 'unknown')} ·
          status/error: ${escapeHtml(debug.status || debug.errorMessage || 'unknown')}
        </small>
      ` : '';
      this.root.querySelectorAll('[data-main-result], [data-secondary-result], [data-tertiary-result]').forEach((target, index) => {
        target.innerHTML = index === 0 ? `
          <div class="solvi-quiz-shell__result-inner">
            <h3>We lost the scent trail for a second.</h3>
            <div class="rte"><p>Give us one more sniff and we'll try again.</p></div>
            <button class="solvi-quiz-shell__retry" type="button" data-quiz-retry>Try again</button>
            ${debugMarkup}
          </div>
        ` : '';
      });
    }

    setResultCardsMode(mode) {
      const single = mode === 'single';
      const layout = this.root.querySelector('.solvi-quiz-shell__result-layout');
      if (layout) layout.classList.toggle('solvi-quiz-shell__result-layout--single', single);
      this.root.querySelectorAll('.solvi-quiz-shell__result-card').forEach((card, index) => {
        card.hidden = single && index > 0;
      });
    }

    retryResults() {
      this.productLoadPromise = null;
      this.productLoadError = null;
      this.showResults();
    }

    renderResult(selector, result) {
      const target = this.root.querySelector(selector);
      if (!target) return;
      if (!result) {
        target.innerHTML = `
          <div class="solvi-quiz-shell__result-inner">
            <h3>No clean match yet</h3>
            <div class="rte"><p>Your dealbreakers filtered out the available product data. Try fewer absolute no’s, or ask us for a human sniff.</p></div>
          </div>
        `;
        return;
      }

      const product = result.product;
      const familyLine = [product.primaryFamily, ...product.scentMoods].filter(Boolean).join(' · ');
      const shelfCopy = result.whyItMadeTheShelf || whyCopy(result);
      target.innerHTML = `
        <div class="solvi-quiz-shell__result-inner solvi-quiz-shell__product-result">
          ${product.featuredImage ? `<a class="solvi-quiz-shell__result-image-link" href="${escapeHtml(product.url)}"><img class="solvi-quiz-shell__result-image" src="${escapeHtml(product.featuredImage)}" alt="${escapeHtml(product.title)}" loading="lazy"></a>` : ''}
          ${product.vendor ? `<p class="solvi-quiz-shell__result-vendor">${escapeHtml(product.vendor)}</p>` : ''}
          <h3><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h3>
          ${familyLine ? `<p class="solvi-quiz-shell__result-meta">${escapeHtml(familyLine)}</p>` : ''}
          <div class="rte"><p><strong>WHY IT MADE THE SHELF</strong><br>${escapeHtml(shelfCopy)}</p></div>
          <a class="solvi-quiz-shell__result-link" href="${escapeHtml(product.url)}">meet this scent →</a>
        </div>
      `;
    }

    restart() {
  this.resultRequestId += 1;

  /* Force fresh product data on the next completed quiz. */
  this.productLoadPromise = null;
  this.productLoadError = null;
  this.latestResults = [];

  this.state = { path: '', answers: {}, freeText: {} };
  this.activePath = '';
  this.activeQuestions = [];
  this.currentIndex = 0;

  try {
    global.localStorage.removeItem(QUIZ_RESULT_STORAGE_KEY);
  } catch (error) {
    // Non-fatal. The quiz can still restart normally.
  }

  if (this.mount) this.mount.innerHTML = '';

  this.root
    .querySelectorAll('[data-main-result], [data-secondary-result], [data-tertiary-result]')
    .forEach((target) => {
      target.innerHTML = '';
    });

  this.showScreen('intro');

  const heading = this.intro && this.intro.querySelector('[data-intro-heading]');
  const isMobile = global.matchMedia('(max-width: 767px)').matches;

  if (heading) heading.focus({ preventScroll: isMobile });

  if (isMobile) {
    global.requestAnimationFrame(() => {
      global.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}

    setNote(message) {
      if (this.note) this.note.textContent = message;
    }
  }

  function init(scope = global.document) {
    if (!scope) return;
    scope.querySelectorAll('[data-solvi-quiz-shell]').forEach((root) => new SolviQuizShell(root));
  }

  const Engine = {
    QUESTIONS,
    NOTE_GROUPS,
    INTENSITY_LEVELS,
    BLIND_BUY_LEVELS,
    buildProfile,
    normalizeProduct,
    scoreProduct,
    rankProducts,
    selectResults,
    whyCopy
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = Engine;
  global.SolviQuizEngine = Engine;

  if (global.document) {
    if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', () => init());
    else init();
    global.document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
})(typeof window !== 'undefined' ? window : globalThis);
